import { includes, pickBy } from 'lodash';
import { generateKeys, generateLocalization } from '../utils';
import { companies } from './companies';
const apTestSteps = generateLocalization('apTestSteps', generateKeys({
    knowledgeDemonstation: {
        stepPosition: 0,
        label: 'Knowledge Demonstration',
        localization: { id: '', defaultMessage: '' },
    },
    financialSituation: {
        stepPosition: 1,
        label: 'Financial Situation',
        localization: { id: '', defaultMessage: '' },
    },
    personalExperience: {
        stepPosition: 2,
        label: 'About your Experience',
        localization: { id: '', defaultMessage: '' },
    },
}));
const getApplicableOptions = (options, version) => {
    return pickBy(options, (o) => !o.applicableVersions || includes(o.applicableVersions, version));
};
const appropTestAnnualIncome = generateLocalization('appropTestAnnualIncome', generateKeys({
    lessThan50k: {
        value: 'less_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: 'Less than 50,000',
        forex_points: 0,
        binary_points: 0,
        max_value: 50000,
        disable: true,
    },
    lessThan10k: {
        value: 'less_than_10k',
        localization: { id: '', defaultMessage: '' },
        label: '0-10,000',
        forex_points: 0,
        binary_points: 0,
        max_value: 10000,
    },
    between10kAnd50k: {
        value: 'between_10k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '10,000-50,000',
        forex_points: 0,
        binary_points: 0,
        max_value: 50000,
    },
    between50kAnd100k: {
        value: 'between_50k_and_100k',
        localization: { id: '', defaultMessage: '' },
        label: '50,000-100,000',
        forex_points: 0,
        binary_points: 0,
        max_value: 100000,
    },
    moreThan100k: {
        value: 'more_than_100k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000+',
        forex_points: 0,
        binary_points: 0,
        max_value: Infinity,
        disable: true,
    },
    between100kAnd200k: {
        value: 'between_100k_and_200k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000-200,000',
        forex_points: 0,
        binary_points: 0,
        max_value: 200000,
    },
    moreThan200k: {
        value: 'more_than_200k',
        localization: { id: '', defaultMessage: '' },
        label: '200,000+',
        forex_points: 0,
        binary_points: 0,
        max_value: Infinity,
    },
}));
const profileNetWorth = generateLocalization('profileNetWorth', generateKeys({
    lessThan50k: {
        value: 'less_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: 'Less than 50,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 50000,
        disable: true,
    },
    between_0k_and_50k: {
        value: 'between_0k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '0-50,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 50000,
    },
    between50kAnd100k: {
        value: 'between_50k_and_100k',
        localization: { id: '', defaultMessage: '' },
        label: '50,000-100,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 100000,
    },
    between100kAnd300k: {
        value: 'between_100k_and_300k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000-300,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 300000,
    },
    moreThan300k: {
        value: 'more_than_300k',
        localization: { id: '', defaultMessage: '' },
        label: '300,000+',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 350000,
    },
}));
const appropTestNetWorth = generateLocalization('appropTestNetWorth', generateKeys({
    lessThan50k: {
        value: 'less_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: 'Less than 50,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0.6,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0.6,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        numeric_value: 50000,
    },
    lessThan20k: {
        value: 'less_than_20k',
        localization: { id: '', defaultMessage: '' },
        label: '0-20,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 20000,
        applicableVersions: [1],
    },
    between20kAnd50k: {
        value: 'between_20k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '20,000-50,000',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 50000,
        applicableVersions: [1],
    },
    between50kAnd100k: {
        value: 'between_50k_and_100k',
        localization: { id: '', defaultMessage: '' },
        label: '50,000-100,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1.3,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 1.3,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
        },
        binary_points: 0,
        numeric_value: 100000,
    },
    moreThan100k: {
        value: 'more_than_100k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000+',
        forex_points: 0,
        binary_points: 0,
        numeric_value: 150000,
        applicableVersions: [1],
    },
    between100kAnd200k: {
        value: 'between_100k_and_200k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000-200,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1.9,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 1.9,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        numeric_value: 200000,
        applicableVersions: [2],
    },
    moreThan200k: {
        value: 'more_than_200k',
        localization: { id: '', defaultMessage: '' },
        label: '200,000+',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        numeric_value: 250000,
        applicableVersions: [2],
    },
}));
const appropTestDisposableIncome = generateLocalization('appropTestDisposableIncome', generateKeys({
    lessThan200: {
        value: 'less_than_200',
        localization: { id: '', defaultMessage: '' },
        label: 'below 200',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1,
            [companies.bdSwissMauritius.key]: 1,
            [companies.bdSwissVanuatu.key]: 1,
            [companies.bdSwissSouthAfrica.key]: 1,
            [companies.bdSwissComoros.key]: 1,
            [companies.swissMarkets.key]: 1,
            [companies.swissMarketsMauritius.key]: 1,
            [companies.swissMarketsVanuatu.key]: 1,
        },
        binary_points: 0,
        numeric_value: 200,
    },
    between200kAnd1k: {
        value: 'between_200_and_1k',
        localization: { id: '', defaultMessage: '' },
        label: 'between 200-1000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.6,
            [companies.bdSwissMauritius.key]: 5,
            [companies.bdSwissVanuatu.key]: 5,
            [companies.bdSwissSouthAfrica.key]: 5,
            [companies.bdSwissComoros.key]: 5,
            [companies.swissMarkets.key]: 2.6,
            [companies.swissMarketsMauritius.key]: 5,
            [companies.swissMarketsVanuatu.key]: 5,
        },
        binary_points: 0,
        numeric_value: 1000,
    },
    moreThan1k: {
        value: 'more_than_1k',
        localization: { id: '', defaultMessage: '' },
        label: '1,000+',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 10,
            [companies.bdSwissVanuatu.key]: 10,
            [companies.bdSwissSouthAfrica.key]: 10,
            [companies.bdSwissComoros.key]: 10,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 10,
            [companies.swissMarketsVanuatu.key]: 10,
        },
        binary_points: 0,
        numeric_value: 250000,
    },
}));
const appropTestEmploymentStatus = generateLocalization('appropTestEmploymentStatus', generateKeys({
    employed: {
        value: 'employed',
        localization: { id: '', defaultMessage: '' },
        label: 'Employed',
        forex_points: 0,
        binary_points: 0,
    },
    selfEmployed: {
        value: 'self-employed',
        localization: { id: '', defaultMessage: '' },
        label: 'Self-Employed',
        forex_points: 0,
        binary_points: 0,
    },
    student: {
        value: 'student',
        localization: { id: '', defaultMessage: '' },
        label: 'Student',
        forex_points: 0,
        binary_points: 0,
    },
    retired: {
        value: 'retired',
        localization: { id: '', defaultMessage: '' },
        label: 'Retired',
        forex_points: 0,
        binary_points: 0,
    },
    notWorking: {
        value: 'not_working',
        localization: { id: '', defaultMessage: '' },
        label: 'Unemployed',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestEmployerCategory = generateLocalization('appropTestEmployerCategory', generateKeys({
    accountancy: {
        value: 'accountancy',
        localization: { id: '', defaultMessage: '' },
        label: 'Accountancy',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    adminSecretarial: {
        value: 'admin_secretarial',
        localization: { id: '', defaultMessage: '' },
        label: 'Admin/Secretarial',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    agriculture: {
        value: 'agriculture',
        localization: { id: '', defaultMessage: '' },
        label: 'Agriculture',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    automotive: {
        value: 'automotive',
        localization: { id: '', defaultMessage: '' },
        label: 'Automotive',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    civilServant: {
        value: 'civil_servant',
        localization: { id: '', defaultMessage: '' },
        label: 'Civil Servant/Public Officials',
        forex_points: 0,
        binary_points: 0,
        disableV2: true,
    },
    relegiousOrganizations: {
        value: 'relegious_organizations',
        localization: { id: '', defaultMessage: '' },
        label: 'Clergy & Religious Organizations',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    cateringHospitality: {
        value: 'catering_hospitality',
        localization: { id: '', defaultMessage: '' },
        label: 'Catering/Hospitality',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    creativeMedia: {
        value: 'creative_media',
        localization: { id: '', defaultMessage: '' },
        label: 'Creative/Media',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    education: {
        value: 'education',
        localization: { id: '', defaultMessage: '' },
        label: 'Education',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    emergencyServices: {
        value: 'emergency_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Emergency Services',
        forex_points: 0,
        binary_points: 0,
    },
    engineering: {
        value: 'engineering',
        localization: { id: '', defaultMessage: '' },
        label: 'Engineering',
        forex_points: 0,
        binary_points: 0,
    },
    financialServices: {
        value: 'financial_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial Services',
        forex_points: 0,
        binary_points: 0,
    },
    healthMedicine: {
        value: 'health_medicine',
        localization: { id: '', defaultMessage: '' },
        label: 'Health/Medicine',
        forex_points: 0,
        binary_points: 0,
    },
    armedForces: {
        value: 'armed_forces',
        localization: { id: '', defaultMessage: '' },
        label: 'HM Forces',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    humanResources: {
        value: 'human_resources',
        localization: { id: '', defaultMessage: '' },
        label: 'HR',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    informationTechnologies: {
        value: 'information_technologies',
        localization: { id: '', defaultMessage: '' },
        label: 'Computing',
        forex_points: 0,
        binary_points: 0,
    },
    insurance: {
        value: 'insurance',
        localization: { id: '', defaultMessage: '' },
        label: 'Insurance',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    legal: {
        value: 'legal',
        localization: { id: '', defaultMessage: '' },
        label: 'Legal',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    leisureEntertainmentTourism: {
        value: 'leisure_entertainment_tourism',
        localization: { id: '', defaultMessage: '' },
        label: 'Leisure/Tourism',
        forex_points: 0,
        binary_points: 0,
    },
    manufacturing: {
        value: 'manufacturing',
        localization: { id: '', defaultMessage: '' },
        label: 'Manufacturing',
        forex_points: 0,
        binary_points: 0,
    },
    marketingPrAdvertising: {
        value: 'marketing_pr_advertising',
        localization: { id: '', defaultMessage: '' },
        label: 'Marketing/PR/Advertising',
        forex_points: 0,
        binary_points: 0,
    },
    pharmaceuticals: {
        value: 'pharmaceuticals',
        localization: { id: '', defaultMessage: '' },
        label: 'Pharmaceuticals',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    propertyConstructionsTrades: {
        value: 'property_constructions_trades',
        localization: { id: '', defaultMessage: '' },
        label: 'Property Construction/Real Estate',
        forex_points: 0,
        binary_points: 0,
    },
    retail: {
        value: 'retail',
        localization: { id: '', defaultMessage: '' },
        label: 'Retail',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    sales: {
        value: 'sales',
        localization: { id: '', defaultMessage: '' },
        label: 'Sales',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    socialCareServices: {
        value: 'social_care_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Social Care/Services',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    telecommunications: {
        value: 'telecommunications',
        localization: { id: '', defaultMessage: '' },
        label: 'Telecommunications',
        forex_points: 0,
        binary_points: 0,
    },
    transportLogistics: {
        value: 'transport_logistics',
        localization: { id: '', defaultMessage: '' },
        label: 'Transport/Logistics',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [2],
    },
    foodAndBeverage: {
        value: 'food_and_beverage',
        localization: { id: '', defaultMessage: '' },
        label: 'Food & Beverage',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    sports: {
        value: 'sports',
        localization: { id: '', defaultMessage: '' },
        label: 'Sports',
        forex_points: 0,
        binary_points: 0,
    },
    insuranceAndRealEstate: {
        value: 'insurance_and_real_estate',
        localization: { id: '', defaultMessage: '' },
        label: 'Insurance & Real Estate',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other Industry',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestSourceOfFunds = generateLocalization('appropTestSourceOfFunds', generateKeys({
    employment: {
        value: 'employment',
        localization: { id: '', defaultMessage: '' },
        label: 'Employment',
        forex_points: 0,
        binary_points: 0,
    },
    inheritance: {
        value: 'inheritance',
        localization: { id: '', defaultMessage: '' },
        label: 'Inheritance',
        forex_points: 0,
        binary_points: 0,
    },
    investment: {
        value: 'investment',
        localization: { id: '', defaultMessage: '' },
        label: 'Investment',
        forex_points: 0,
        binary_points: 0,
    },
    realEstate: {
        value: 'real_estate',
        localization: { id: '', defaultMessage: '' },
        label: 'Real Estate',
        forex_points: 0,
        binary_points: 0,
    },
    savings: {
        value: 'savings',
        localization: { id: '', defaultMessage: '' },
        label: 'Savings',
        forex_points: 0,
        binary_points: 0,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        binary_points: 0,
    },
    gift: {
        value: 'gift',
        localization: { id: '', defaultMessage: '' },
        label: 'Gift',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    pension: {
        value: 'pension',
        localization: { id: '', defaultMessage: '' },
        label: 'Pension',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
}));
const appropTestExpectedDeposit = generateLocalization('appropTestExpectedDeposit', generateKeys({
    lessThan1k: {
        value: 'less_than_1k',
        localization: { id: '', defaultMessage: '' },
        label: '0-1,000',
        applicableVersions: [1],
    },
    between1kAnd10k: {
        value: 'between_1k_and_10k',
        localization: { id: '', defaultMessage: '' },
        label: '1,000-10,000',
        applicableVersions: [1],
    },
    moreThan10k: {
        value: 'more_than_10k',
        localization: { id: '', defaultMessage: '' },
        label: '10,000+',
        applicableVersions: [1],
    },
    lessThan2k: {
        value: 'less_than_2k',
        localization: { id: '', defaultMessage: '' },
        label: '0-2,000',
        applicableVersions: [2],
    },
    between2kAnd10k: {
        value: 'between_2k_and_10k',
        localization: { id: '', defaultMessage: '' },
        label: '2,000-10,000',
        applicableVersions: [2],
    },
    between10kAnd25k: {
        value: 'between_10k_and_25k',
        localization: { id: '', defaultMessage: '' },
        label: '10,000-25,000',
        applicableVersions: [2],
    },
    moreThan25k: {
        value: 'more_than_25000',
        localization: { id: '', defaultMessage: '' },
        label: '25,000+',
        applicableVersions: [2],
    },
}));
const appropTestAttendedSeminarOrCourse = generateLocalization('appropTestAttendedSeminarOrCourse', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
    },
}));
const appropTestEducationLevel = generateLocalization('appropTestEducationLevel', generateKeys({
    HighSchoolOrEquivalent: {
        value: 'high_school_or_equivalent',
        localization: { id: '', defaultMessage: '' },
        label: 'High School',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    bachelorDiplomaDegree: {
        value: 'bachelor_diploma_degree',
        localization: { id: '', defaultMessage: '' },
        label: 'Bachelor Degree/Diploma',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    masterDegree: {
        value: 'master_degree',
        localization: { id: '', defaultMessage: '' },
        label: 'Master Degree',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    doctorateDegree: {
        value: 'doctorate_degree',
        localization: { id: '', defaultMessage: '' },
        label: 'Doctorate Degree',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    otherProfessionalQualifications: {
        value: 'other_professional_qualifications',
        localization: { id: '', defaultMessage: '' },
        label: 'Other Professional Qualifications',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    UniversityDegreeOrEquivalent: {
        value: 'university_degree_or_equivalent',
        localization: { id: '', defaultMessage: '' },
        label: 'University Degree or Equivalent',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    professionalQualification: {
        value: 'professional_qualification',
        localization: { id: '', defaultMessage: '' },
        label: 'Professional Qualification',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 12,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 12,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
        applicableVersions: [2],
    },
    universityCollege: {
        value: 'university_college',
        localization: { id: '', defaultMessage: '' },
        label: 'University/College',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 9,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 9,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
        applicableVersions: [2],
    },
    secondaryEducation: {
        value: 'secondary_education',
        localization: { id: '', defaultMessage: '' },
        label: 'Secondary Education',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 6,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
        applicableVersions: [2],
    },
    primaryEducation: {
        value: 'primary_education',
        localization: { id: '', defaultMessage: '' },
        label: 'Primary Education',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 3,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
        applicableVersions: [2],
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestProfessionStatus = generateLocalization('appropTestProfessionStatus', generateKeys({
    professionAccounting: {
        value: 'profession_accounting',
        localization: { id: '', defaultMessage: '' },
        label: 'Profession - Accounting, Banking, Business, Economics, Finance, Law or similar',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 7.5,
            [companies.bdSwissVanuatu.key]: 7.5,
            [companies.bdSwissSouthAfrica.key]: 7.5,
            [companies.bdSwissComoros.key]: 7.5,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 7.5,
            [companies.swissMarketsVanuatu.key]: 7.5,
        },
    },
    professionSciences: {
        value: 'profession_sciences',
        localization: { id: '', defaultMessage: '' },
        label: 'Profession - Computer science, IT, Engineering, Architecture or similar or  Medicine and Sciences or similar',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 5.6,
            [companies.bdSwissVanuatu.key]: 5.6,
            [companies.bdSwissSouthAfrica.key]: 5.6,
            [companies.bdSwissComoros.key]: 5.6,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 5.6,
            [companies.swissMarketsVanuatu.key]: 5.6,
        },
    },
    professionOther: {
        value: 'profession_other',
        localization: { id: '', defaultMessage: '' },
        label: 'Profession - Other',
        forex_points: 3,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0.75,
            [companies.bdSwissVanuatu.key]: 0.75,
            [companies.bdSwissSouthAfrica.key]: 0.75,
            [companies.bdSwissComoros.key]: 0.75,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0.75,
            [companies.swissMarketsVanuatu.key]: 0.75,
        },
    },
    retired: {
        value: 'retired',
        localization: { id: '', defaultMessage: '' },
        label: 'Retired',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        disable: true,
    },
    student: {
        value: 'student',
        localization: { id: '', defaultMessage: '' },
        label: 'Student',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        disable: true,
    },
}));
const appropTestFieldOfStudy = generateLocalization('appropTestFieldOfStudy', generateKeys({
    accountingBanking: {
        value: 'accounting_banking',
        localization: { id: '', defaultMessage: '' },
        label: 'Accounting, Banking, Business, Economics, Finance, Law or similar',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 8,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 8,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    computerScience: {
        value: 'computer_science',
        localization: { id: '', defaultMessage: '' },
        label: 'Computer science, IT, Engineering, Architecture or similar',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 6,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    medicine: {
        value: 'medicine',
        localization: { id: '', defaultMessage: '' },
        label: 'Medicine and Sciences or similar',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 6,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    art: {
        value: 'art',
        localization: { id: '', defaultMessage: '' },
        label: 'Arts, Fashion, Languages, Media or similar',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropNatureOfTransactions = generateLocalization('appropNatureOfTransactions', generateKeys({
    shortTermInvestments: {
        value: 'short_term_investments',
        localization: { id: '', defaultMessage: '' },
        label: 'Short Term Investments',
        forex_points: 0,
        binary_points: 0,
    },
    longTermInvestments: {
        value: 'short_term_investments',
        localization: { id: '', defaultMessage: '' },
        label: 'Long Term Investments',
        forex_points: 0,
        binary_points: 0,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropOriginOfFunds = generateLocalization('appropOriginOfFunds', generateKeys({
    creditCard: {
        value: 'credit_card',
        localization: { id: '', defaultMessage: '' },
        label: 'Credit card',
        forex_points: 0,
        binary_points: 0,
    },
    bankTransfer: {
        value: 'bank_transfer',
        localization: { id: '', defaultMessage: '' },
        label: 'Bank Transfer',
        forex_points: 0,
        binary_points: 0,
    },
    apmTransactions: {
        value: 'APM transactions',
        localization: { id: '', defaultMessage: '' },
        label: 'APM transactions',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestHaveTraded = generateLocalization('appropTestHaveTraded', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 10,
        binary_points: 10,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestHowManyTimesHaveTraded = generateLocalization('appropTestHowManyTimesHaveTraded', generateKeys({
    moreThan25: {
        value: 'more_than_25',
        localization: { id: '', defaultMessage: '' },
        label: '0-25',
    },
    between10And25: {
        value: 'between_10_and_25',
        localization: { id: '', defaultMessage: '' },
        label: '10-25',
    },
    never: {
        value: 'never',
        localization: { id: '', defaultMessage: '' },
        label: 'Never',
    },
}));
const appropTestIsUsReportable = generateLocalization('appropTestIsUsReportable', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 0,
        binary_points: 0,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestPoliticallyExposed = generateLocalization('appropTestPoliticallyExposed', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 0,
        binary_points: 0,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestInitialInvestment = generateLocalization('appropTestInitialInvestment', generateKeys({
    between0And2000: {
        value: 'between_0_and_2000',
        localization: { id: '', defaultMessage: '' },
        label: '0-2000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 3.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        applicableVersions: [2],
    },
    between2kAnd20k: {
        value: 'between_2k_and_20k',
        localization: { id: '', defaultMessage: '' },
        label: '2,000-20,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.6,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.6,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        applicableVersions: [2],
    },
    moreThan20k: {
        value: 'more_than_20k',
        localization: { id: '', defaultMessage: '' },
        label: '20,000+',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1.8,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 1.8,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        applicableVersions: [2],
    },
    multiple: {
        value: 'multiple',
        localization: { id: '', defaultMessage: '' },
        label: 'Multiple of the above mentioned amounts owing to leverage',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0.9,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0.9,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        applicableVersions: [2],
    },
    between0And5000: {
        value: 'between_0_and_5000',
        localization: { id: '', defaultMessage: '' },
        label: '0-5000',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    between5000And25000: {
        value: 'between_0_and_250',
        localization: { id: '', defaultMessage: '' },
        label: '5000-25000',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    moreThan25000: {
        value: 'more_than_25000',
        localization: { id: '', defaultMessage: '' },
        label: '25000+',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    between0And250: {
        value: 'between_0_and_250',
        localization: { id: '', defaultMessage: '' },
        label: '0-250',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between250And1k: {
        value: 'between_250_and_1k',
        localization: { id: '', defaultMessage: '' },
        label: '250-1,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between1kAnd5k: {
        value: 'between_1k_and_5k',
        localization: { id: '', defaultMessage: '' },
        label: '1,000-5,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between5kAnd10k: {
        value: 'between_5k_and_10k',
        localization: { id: '', defaultMessage: '' },
        label: '5,000-10,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between10kAnd50k: {
        value: 'between_10k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '10,000-50,000',
        forex_points: 8,
        binary_points: 8,
        disable: true,
    },
    moreThan50k: {
        value: 'more_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: '50,000+',
        forex_points: 10,
        binary_points: 10,
        disable: true,
    },
}));
const appropTestPast2YearsTradingExperience = generateLocalization('appropTestPast2YearsTradingExperience', generateKeys({
    tradedOnMyOwn: {
        value: 'traded_on_my_own',
        localization: { id: '', defaultMessage: '' },
        label: 'Mostly traded on my own',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 45,
            [companies.bdSwissVanuatu.key]: 45,
            [companies.bdSwissSouthAfrica.key]: 45,
            [companies.bdSwissComoros.key]: 45,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 45,
            [companies.swissMarketsVanuatu.key]: 45,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    tradedWithAdvice: {
        value: 'traded_with_advice',
        localization: { id: '', defaultMessage: '' },
        label: 'Mostly traded with advice or through a managed portfolio',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.bdSwissMauritius.key]: 30,
            [companies.bdSwissVanuatu.key]: 30,
            [companies.bdSwissSouthAfrica.key]: 30,
            [companies.bdSwissComoros.key]: 30,
            [companies.swissMarkets.key]: 5,
            [companies.swissMarketsMauritius.key]: 30,
            [companies.swissMarketsVanuatu.key]: 30,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    workedInFinancialIndustry: {
        value: 'worked_in_financial_industry',
        localization: { id: '', defaultMessage: '' },
        label: 'Worked in a related role in the financial industry',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 15,
            [companies.bdSwissVanuatu.key]: 15,
            [companies.bdSwissSouthAfrica.key]: 15,
            [companies.bdSwissComoros.key]: 15,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 15,
            [companies.swissMarketsVanuatu.key]: 15,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    attendedSeminars: {
        value: 'attended_seminars',
        localization: { id: '', defaultMessage: '' },
        label: 'Attended relevant seminars and tutorials relating to trading',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 15,
            [companies.bdSwissVanuatu.key]: 15,
            [companies.bdSwissSouthAfrica.key]: 15,
            [companies.bdSwissComoros.key]: 15,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 15,
            [companies.swissMarketsVanuatu.key]: 15,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    atLeast2: {
        value: 'at_least_2',
        localization: { id: '', defaultMessage: '' },
        label: 'Performed at least 2 of the above',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.bdSwissMauritius.key]: 45,
            [companies.bdSwissVanuatu.key]: 45,
            [companies.bdSwissSouthAfrica.key]: 45,
            [companies.bdSwissComoros.key]: 45,
            [companies.swissMarkets.key]: 10,
            [companies.swissMarketsMauritius.key]: 45,
            [companies.swissMarketsVanuatu.key]: 45,
        },
        binary_points: 0,
        applicableVersions: [1, 2],
    },
    notTraded: {
        value: 'not_traded',
        localization: { id: '', defaultMessage: '' },
        label: 'Not Traded',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestTransactionsInForex = generateLocalization('appropTestTransactionsInForex', generateKeys({
    moreThan250k: {
        value: 'more_than_250k',
        localization: { id: '', defaultMessage: '' },
        label: 'Over 250,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 10,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    between50kAnd250k: {
        value: 'between_50k_and_250k',
        localization: { id: '', defaultMessage: '' },
        label: '50,001-250,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    between5kAnd50k: {
        value: 'between_5k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '5,001-50,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    lessThan5k: {
        value: 'less_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: '0-5,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestTransactionsInCommodities = generateLocalization('appropTestTransactionsInCommodities', generateKeys({
    moreThan250k: {
        value: 'more_than_250k',
        localization: { id: '', defaultMessage: '' },
        label: 'Over 250,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 10,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    between50kAnd250k: {
        value: 'between_50k_and_250k',
        localization: { id: '', defaultMessage: '' },
        label: '50,001-250,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    between5kAnd50k: {
        value: 'between_5k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '5,001-50,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    lessThan5k: {
        value: 'less_than_5k',
        localization: { id: '', defaultMessage: '' },
        label: '0-5,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestWithLeverageForex = generateLocalization('appropTestWithLeverageForex', generateKeys({
    moreThan40: {
        value: 'more_than_40',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 40',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 10,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    between26And40: {
        value: 'between_26_and_40',
        localization: { id: '', defaultMessage: '' },
        label: '26-40',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    between11And25: {
        value: 'between_11_and_25',
        localization: { id: '', defaultMessage: '' },
        label: '11-25',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    between1And10: {
        value: 'between_11_and_10',
        localization: { id: '', defaultMessage: '' },
        label: '1-10',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestWithLeverageCommodities = generateLocalization('appropTestWithLeverageCommodities', generateKeys({
    moreThan40: {
        value: 'more_than_40',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 40',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 10,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 5,
    },
    between26And40: {
        value: 'between_26_and_40',
        localization: { id: '', defaultMessage: '' },
        label: '26-40',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 7.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 4,
    },
    between11And25: {
        value: 'between_11_and_25',
        localization: { id: '', defaultMessage: '' },
        label: '11-25',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 3,
    },
    between1And10: {
        value: 'between_11_and_10',
        localization: { id: '', defaultMessage: '' },
        label: '1-10',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2.5,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 2.5,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 2,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
        portfolio_points: 1,
    },
}));
const appropTestStockDrops = generateLocalization('appropTestStockDrops', generateKeys({
    oppositeDirection: {
        value: 'opposite_direction',
        localization: { id: '', defaultMessage: '' },
        label: 'The price of the APPLE CFD will move in the opposite direction',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    notAffected: {
        value: 'not_affected',
        localization: { id: '', defaultMessage: '' },
        label: 'The price of the APPLE CFD will not be affected',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    sameDirection: {
        value: 'same_direction',
        localization: { id: '', defaultMessage: '' },
        label: 'The price of the APPLE CFD will move in the same direction',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestBuyFacebookCfd = generateLocalization('appropTestBuyFacebookCfd', generateKeys({
    sellThroughBdswiss: {
        value: 'opposite_direction',
        localization: { id: '', defaultMessage: '' },
        label: 'You can only sell it through the {{domain}} platform',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    sellAtStockExchange: {
        value: 'sell_at_stock_exchange',
        localization: { id: '', defaultMessage: '' },
        label: 'You can sell it at the London Stock Exchange',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    cannotSell: {
        value: 'cannot_sell',
        localization: { id: '', defaultMessage: '' },
        label: 'You cannot sell it',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestMaximumPosition = generateLocalization('appropTestMaximumPosition', generateKeys({
    maximumPosition5k: {
        value: 'maximum_position_5k',
        localization: { id: '', defaultMessage: '' },
        label: '€3,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    maximumPosition50k: {
        value: 'maximum_position_50k',
        localization: { id: '', defaultMessage: '' },
        label: '€30,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    maximumPosition500k: {
        value: 'maximum_position_500k',
        localization: { id: '', defaultMessage: '' },
        label: '€300,000',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestTradingWithLeverage = generateLocalization('appropTestTradingWithLeverage', generateKeys({
    riskFree: {
        value: 'risk_free',
        localization: { id: '', defaultMessage: '' },
        label: 'Trading with leverage is risk free',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    increaseProfits: {
        value: 'increase_profits',
        localization: { id: '', defaultMessage: '' },
        label: 'Leverage has the potential to increase your profits or losses by the same magnitute',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None of the above',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestCfdTrading = generateLocalization('appropTestCfdTrading', generateKeys({
    doNotHaveOwnership: {
        value: 'do_not_have_ownership',
        localization: { id: '', defaultMessage: '' },
        label: 'When trading CFD’s you do not have ownership of the actual underlying asset.',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    complexProducts: {
        value: 'complex_products',
        localization: { id: '', defaultMessage: '' },
        label: 'CFD’s are considered complex financial products',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    all: {
        value: 'all',
        localization: { id: '', defaultMessage: '' },
        label: 'All of the above',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 4,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestAccountTurnover = generateLocalization('appropTestAccountTurnover', generateKeys({
    between0And5000: {
        value: 'between_0_and_5000',
        localization: { id: '', defaultMessage: '' },
        label: '0-5000',
        forex_points: 0,
        binary_points: 0,
    },
    between5000And25000: {
        value: 'between_0_and_250',
        localization: { id: '', defaultMessage: '' },
        label: '5000-25000',
        forex_points: 0,
        binary_points: 0,
    },
    moreThan25000: {
        value: 'more_than_25000',
        localization: { id: '', defaultMessage: '' },
        label: '25000+',
        forex_points: 0,
        binary_points: 0,
    },
    between0And1k: {
        value: 'between_0_and_1k',
        localization: { id: '', defaultMessage: '' },
        label: '0-1,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between1kAnd5k: {
        value: 'between_1k_and_5k',
        localization: { id: '', defaultMessage: '' },
        label: '1,000-5,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    between5kAnd50k: {
        value: 'between_5k_and_50k',
        localization: { id: '', defaultMessage: '' },
        label: '5,000-50,000',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
    moreThan50k: {
        value: 'more_than_50k',
        localization: { id: '', defaultMessage: '' },
        label: '50,000+',
        forex_points: 0,
        binary_points: 0,
        disable: true,
    },
}));
const profileTransactionPurpose = generateLocalization('profileTransactionPurpose', generateKeys({
    speculative: {
        value: 'speculative',
        localization: { id: '', defaultMessage: '' },
        label: 'Speculative',
        forex_points: 0,
        binary_points: 0,
    },
    incomeEarning: {
        value: 'income_earning',
        localization: { id: '', defaultMessage: '' },
        label: 'Income Earning',
        forex_points: 0,
        binary_points: 0,
    },
    savings: {
        value: 'savings',
        localization: { id: '', defaultMessage: '' },
        label: 'Savings',
        forex_points: 0,
        binary_points: 0,
    },
    hedging: {
        value: 'hedging',
        localization: { id: '', defaultMessage: '' },
        label: 'Hedging',
        forex_points: 0,
        binary_points: 0,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestTransactionPurpose = generateLocalization('appropTestTransactionPurpose', generateKeys({
    speculative: {
        value: 'speculative',
        localization: { id: '', defaultMessage: '' },
        label: 'Speculative',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 8,
            [companies.bdSwissMauritius.key]: 7.5,
            [companies.bdSwissVanuatu.key]: 7.5,
            [companies.bdSwissSouthAfrica.key]: 7.5,
            [companies.bdSwissComoros.key]: 7.5,
            [companies.swissMarkets.key]: 8,
            [companies.swissMarketsMauritius.key]: 7.5,
            [companies.swissMarketsVanuatu.key]: 7.5,
        },
        binary_points: 0,
    },
    intradayTrading: {
        value: 'intraday_trading',
        localization: { id: '', defaultMessage: '' },
        label: 'Intraday Trading',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.bdSwissMauritius.key]: 5.6,
            [companies.bdSwissVanuatu.key]: 5.6,
            [companies.bdSwissSouthAfrica.key]: 5.6,
            [companies.bdSwissComoros.key]: 5.6,
            [companies.swissMarkets.key]: 6,
            [companies.swissMarketsMauritius.key]: 5.6,
            [companies.swissMarketsVanuatu.key]: 5.6,
        },
        binary_points: 0,
    },
    strategyProvider: {
        value: 'strategy_provider',
        localization: { id: '', defaultMessage: '' },
        label: 'Strategy Provider',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
    hedging: {
        value: 'hedging',
        localization: { id: '', defaultMessage: '' },
        label: 'Hedging',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2,
            [companies.bdSwissMauritius.key]: 1.89,
            [companies.bdSwissVanuatu.key]: 1.89,
            [companies.bdSwissSouthAfrica.key]: 1.89,
            [companies.bdSwissComoros.key]: 1.89,
            [companies.swissMarkets.key]: 2,
            [companies.swissMarketsMauritius.key]: 1.89,
            [companies.swissMarketsVanuatu.key]: 1.89,
        },
        binary_points: 0,
    },
    longTermInvestments: {
        value: 'long_term_investments',
        localization: { id: '', defaultMessage: '' },
        label: 'Long Term Investments',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        binary_points: 0,
        applicableVersions: [1],
    },
}));
const appropTestAttendedSeminarOrCourseForex = generateLocalization('appropTestAttendedSeminarOrCourseForex', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 10,
        binary_points: 0,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestAttendedSeminarOrCourseBinary = generateLocalization('appropTestAttendedSeminarOrCourseBinary', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 0,
        binary_points: 10,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestTransactionNumber = generateLocalization('appropTestTransactionNumber', generateKeys({
    between0And5PerMonth: {
        value: 'between_0_and_5_per_month',
        localization: { id: '', defaultMessage: '' },
        label: '0-5',
        forex_points: 0,
        binary_points: 0,
    },
    between6And50PerMonth: {
        value: 'between_6_and_50_per_month',
        localization: { id: '', defaultMessage: '' },
        label: '6-50',
        forex_points: 0,
        binary_points: 0,
    },
    moreThan50PerMonth: {
        value: 'more_than_50_per_month',
        localization: { id: '', defaultMessage: '' },
        label: '50+',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestRelevantProfession = generateLocalization('appropTestRelevantProfession', generateKeys({
    accounting: {
        value: 'accounting',
        localization: { id: '', defaultMessage: '' },
        label: 'Accounting',
        forex_points: 0,
        binary_points: 0,
    },
    banking: {
        value: 'banking',
        localization: { id: '', defaultMessage: '' },
        label: 'Banking',
        forex_points: 0,
        binary_points: 0,
    },
    legal: {
        value: 'legal',
        localization: { id: '', defaultMessage: '' },
        label: 'Legal',
        forex_points: 0,
        binary_points: 0,
    },
    otherFinancialServices: {
        value: 'other_financial_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Other Financial Services',
        forex_points: 10,
        binary_points: 10,
    },
    professionNotRelevant: {
        value: 'professionNotRelevant',
        localization: { id: '', defaultMessage: '' },
        label: 'Profession not relevant',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestRelevantQualOrExp = generateLocalization('appropTestRelevantQualOrExp', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 10,
        binary_points: 10,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestRiskUnderstanding = generateLocalization('appropTestRiskUnderstanding', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 10,
        binary_points: 10,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestTradingExperienceForex = generateLocalization('appropTestTradingExperienceForex', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThan1year: {
        value: 'less_than_1_year',
        localization: { id: '', defaultMessage: '' },
        label: '0-1',
        forex_points: 3,
        binary_points: 0,
    },
    between1And3years: {
        value: 'between_1_and_3_years',
        localization: { id: '', defaultMessage: '' },
        label: '1-3',
        forex_points: 5,
        binary_points: 0,
    },
    between4And7years: {
        value: 'between_4_and_7_years',
        localization: { id: '', defaultMessage: '' },
        label: '4-7',
        forex_points: 7,
        binary_points: 0,
    },
    over8years: {
        value: 'over_8_years',
        localization: { id: '', defaultMessage: '' },
        label: '8+',
        forex_points: 10,
        binary_points: 0,
    },
}));
const appropTestTradingExperienceSharesBonds = generateLocalization('appropTestTradingExperienceSharesBonds', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThan1year: {
        value: 'less_than_1_year',
        localization: { id: '', defaultMessage: '' },
        label: '0-1',
        forex_points: 3,
        binary_points: 3,
    },
    between1And3years: {
        value: 'between_1_and_3_years',
        localization: { id: '', defaultMessage: '' },
        label: '1-3',
        forex_points: 5,
        binary_points: 5,
    },
    between4And7years: {
        value: 'between_4_and_7_years',
        localization: { id: '', defaultMessage: '' },
        label: '4-7',
        forex_points: 7,
        binary_points: 7,
    },
    over8years: {
        value: 'over_8_years',
        localization: { id: '', defaultMessage: '' },
        label: '8+',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestTradingExperienceExchange = generateLocalization('appropTestTradingExperienceExchange', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThan1year: {
        value: 'less_than_1_year',
        localization: { id: '', defaultMessage: '' },
        label: '0-1',
        forex_points: 3,
        binary_points: 3,
    },
    between1And3years: {
        value: 'between_1_and_3_years',
        localization: { id: '', defaultMessage: '' },
        label: '1-3',
        forex_points: 5,
        binary_points: 5,
    },
    between4And7years: {
        value: 'between_4_and_7_years',
        localization: { id: '', defaultMessage: '' },
        label: '4-7',
        forex_points: 7,
        binary_points: 7,
    },
    over8years: {
        value: 'over_8_years',
        localization: { id: '', defaultMessage: '' },
        label: '8+',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestTradingExperienceOTC = generateLocalization('appropTestTradingExperienceOTC', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThan1year: {
        value: 'less_than_1_year',
        localization: { id: '', defaultMessage: '' },
        label: '0-1',
        forex_points: 3,
        binary_points: 3,
    },
    between1And3years: {
        value: 'between_1_and_3_years',
        localization: { id: '', defaultMessage: '' },
        label: '1-3',
        forex_points: 5,
        binary_points: 5,
    },
    between4And7years: {
        value: 'between_4_and_7_years',
        localization: { id: '', defaultMessage: '' },
        label: '4-7',
        forex_points: 7,
        binary_points: 7,
    },
    over8years: {
        value: 'over_8_years',
        localization: { id: '', defaultMessage: '' },
        label: '8+',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestTradingExperienceBinary = generateLocalization('appropTestTradingExperienceBinary', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThan1year: {
        value: 'less_than_1_year',
        localization: { id: '', defaultMessage: '' },
        label: '0-1',
        forex_points: 0,
        binary_points: 3,
    },
    between1And3years: {
        value: 'between_1_and_3_years',
        localization: { id: '', defaultMessage: '' },
        label: '1-3',
        forex_points: 0,
        binary_points: 5,
    },
    between4And7years: {
        value: 'between_4_and_7_years',
        localization: { id: '', defaultMessage: '' },
        label: '4-7',
        forex_points: 0,
        binary_points: 7,
    },
    over8years: {
        value: 'over_8_years',
        localization: { id: '', defaultMessage: '' },
        label: '8+',
        forex_points: 0,
        binary_points: 10,
    },
}));
const appropTestTradingFrequency12Months = generateLocalization('appropTestTradingFrequency12Months', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    between1And5: {
        value: 'between_1_and_5',
        localization: { id: '', defaultMessage: '' },
        label: '1-5',
        forex_points: 3,
        binary_points: 3,
    },
    between6And20: {
        value: 'between_6_and_20',
        localization: { id: '', defaultMessage: '' },
        label: '6-20',
        forex_points: 5,
        binary_points: 5,
    },
    between21And50: {
        value: 'between_21_and_50',
        localization: { id: '', defaultMessage: '' },
        label: '21-50',
        forex_points: 7,
        binary_points: 7,
    },
    moreThan50: {
        value: 'more_than_50',
        localization: { id: '', defaultMessage: '' },
        label: '50+',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestTradingTransactions12Months = generateLocalization('appropTestTradingTransactions12Months', generateKeys({
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None',
        forex_points: 0,
        binary_points: 0,
    },
    lessThanUSD25k: {
        value: 'less_than_usd_25k',
        localization: { id: '', defaultMessage: '' },
        label: '0-25,000',
        forex_points: 3,
        binary_points: 3,
    },
    betweenUSD25kAnd100k: {
        value: 'between_usd_25k_and_100k',
        localization: { id: '', defaultMessage: '' },
        label: '25,000-100,000',
        forex_points: 5,
        binary_points: 5,
    },
    betweenUSD100kAnd250k: {
        value: 'between_usd_100k_and_250k',
        localization: { id: '', defaultMessage: '' },
        label: '100,000-250,000',
        forex_points: 7,
        binary_points: 7,
    },
    overUSD250k: {
        value: 'over_USD_250k',
        localization: { id: '', defaultMessage: '' },
        label: '250,000+',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestHaveTradingExperience = generateLocalization('appropTestHaveTradingExperience', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 100,
        binary_points: 100,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestPast2YearsProductsSwMarkets = generateLocalization('appropTestPast2YearsProductsSwMarkets', generateKeys({
    forex: {
        value: 'forex',
        localization: { id: '', defaultMessage: '' },
        label: 'Forex',
        forex_points: 50,
        binary_points: 0,
    },
    financialDemo: {
        value: 'financialDemo',
        localization: { id: '', defaultMessage: '' },
        label: 'Demo Account',
        forex_points: 50,
        binary_points: 0,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 25,
        binary_points: 0,
    },
}));
const appropTestPast2YearsProductsBdSwiss = generateLocalization('appropTestPast2YearsProductsBdSwiss', generateKeys({
    forex: {
        value: 'forex',
        localization: { id: '', defaultMessage: '' },
        label: 'Forex',
        forex_points: 50,
        binary_points: 50,
    },
    binary: {
        value: 'binary',
        localization: { id: '', defaultMessage: '' },
        label: 'Binary',
        forex_points: 50,
        binary_points: 50,
    },
    financialDemo: {
        value: 'financialDemo',
        localization: { id: '', defaultMessage: '' },
        label: 'Demo Account',
        forex_points: 50,
        binary_points: 50,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 25,
        binary_points: 25,
    },
}));
const appropTestForexPast2YearsExperience = generateLocalization('appropTestForexPast2YearsExperience', generateKeys({
    upTo25: {
        value: 'upTo25',
        localization: { id: '', defaultMessage: '' },
        label: '0-25',
        forex_points: 25,
        binary_points: 0,
    },
    between25to100: {
        value: 'between25to100',
        localization: { id: '', defaultMessage: '' },
        label: '25-100',
        forex_points: 50,
        binary_points: 0,
    },
    over100: {
        value: 'over100',
        localization: { id: '', defaultMessage: '' },
        label: '100+',
        forex_points: 100,
        binary_points: 0,
    },
}));
const appropTestBinaryPast2YearsExperience = generateLocalization('appropTestBinaryPast2YearsExperience', generateKeys({
    upTo25: {
        value: 'upTo25',
        localization: { id: '', defaultMessage: '' },
        label: '0-25',
        forex_points: 0,
        binary_points: 25,
    },
    between25to100: {
        value: 'between25to100',
        localization: { id: '', defaultMessage: '' },
        label: '25-100',
        forex_points: 0,
        binary_points: 50,
    },
    over100: {
        value: 'over100',
        localization: { id: '', defaultMessage: '' },
        label: '100+',
        forex_points: 0,
        binary_points: 100,
    },
}));
const appropTestFinancialDemoPast2YearsExp = generateLocalization('appropTestFinancialDemoPast2YearsExp', generateKeys({
    upTo25: {
        value: 'upTo25',
        localization: { id: '', defaultMessage: '' },
        label: '0-25',
        forex_points: 5,
        binary_points: 5,
    },
    between25to100: {
        value: 'between25to100',
        localization: { id: '', defaultMessage: '' },
        label: '25-100',
        forex_points: 15,
        binary_points: 15,
    },
    over100: {
        value: 'over100',
        localization: { id: '', defaultMessage: '' },
        label: '100+',
        forex_points: 25,
        binary_points: 25,
    },
}));
const appropTestEducatedInFinancialTrading = generateLocalization('appropTestEducatedInFinancialTrading', generateKeys({
    yes: {
        value: 'yes',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes',
        forex_points: 100,
        binary_points: 100,
    },
    no: {
        value: 'no',
        localization: { id: '', defaultMessage: '' },
        label: 'No',
        forex_points: 10,
        binary_points: 10,
    },
}));
const appropTestEducationOptionInFinancialTrading = generateLocalization('appropTestEducationOptionInFinancialTrading', generateKeys({
    higherEducation: {
        value: 'higherEducation',
        localization: { id: '', defaultMessage: '' },
        label: 'Higher Education',
        forex_points: 100,
        binary_points: 100,
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other qualifications',
        forex_points: 50,
        binary_points: 50,
    },
    selfTaught: {
        value: 'selfTaught',
        localization: { id: '', defaultMessage: '' },
        label: 'Self-Taught',
        forex_points: 25,
        binary_points: 25,
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None of the above',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestLargerSizePositions = generateLocalization('appropTestLargerSizePositions', generateKeys({
    true: {
        value: 'true',
        localization: { id: '', defaultMessage: '' },
        label: 'True',
        forex_points: 25,
        binary_points: 25,
    },
    false: {
        value: 'false',
        localization: { id: '', defaultMessage: '' },
        label: '  False',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestLostInvestment = generateLocalization('appropTestLostInvestment', generateKeys({
    true: {
        value: 'true',
        localization: { id: '', defaultMessage: '' },
        label: 'True',
        forex_points: 25,
        binary_points: 25,
    },
    false: {
        value: 'false',
        localization: { id: '', defaultMessage: '' },
        label: '  False',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestVolatileMarkets = generateLocalization('appropTestVolatileMarkets', generateKeys({
    true: {
        value: 'true',
        localization: { id: '', defaultMessage: '' },
        label: 'True',
        forex_points: 25,
        binary_points: 25,
    },
    false: {
        value: 'false',
        localization: { id: '', defaultMessage: '' },
        label: '  False',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestWarningAcceptance = generateLocalization('appropTestWarningAcceptance', generateKeys({
    accept: {
        value: 'accept',
        localization: { id: '', defaultMessage: '' },
        label: 'Accept',
        forex_points: 0,
        binary_points: 0,
    },
    notAccept: {
        value: 'notAccept',
        localization: { id: '', defaultMessage: '' },
        label: 'Not Accept',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestAcknowledgmentAcceptance = generateLocalization('appropTestAcknowledgmentAcceptance', generateKeys({
    acknowledged: {
        value: 'acknowledged',
        localization: { id: '', defaultMessage: '' },
        label: 'Accept',
        forex_points: 0,
        binary_points: 0,
    },
    notAcknowledged: {
        value: 'notAcknowledged',
        localization: { id: '', defaultMessage: '' },
        label: 'Not Accept',
        forex_points: 0,
        binary_points: 0,
    },
}));
const appropTestIfLoseCapital = generateLocalization('appropTestIfLoseCapital', generateKeys({
    tradeAgain: {
        value: 'trade_again',
        localization: { id: '', defaultMessage: '' },
        label: 'Definitely trade again',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 12,
            [companies.bdSwissMauritius.key]: 15,
            [companies.bdSwissVanuatu.key]: 15,
            [companies.bdSwissSouthAfrica.key]: 15,
            [companies.bdSwissComoros.key]: 15,
            [companies.swissMarkets.key]: 12,
            [companies.swissMarketsMauritius.key]: 15,
            [companies.swissMarketsVanuatu.key]: 15,
        },
        binary_points: 0,
    },
    mostLikelyTradeAgain: {
        value: 'most_likely_trade_again',
        localization: { id: '', defaultMessage: '' },
        label: 'Most likely to trade again',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.bdSwissMauritius.key]: 7.5,
            [companies.bdSwissVanuatu.key]: 7.5,
            [companies.bdSwissSouthAfrica.key]: 7.5,
            [companies.bdSwissComoros.key]: 7.5,
            [companies.swissMarkets.key]: 6,
            [companies.swissMarketsMauritius.key]: 7.5,
            [companies.swissMarketsVanuatu.key]: 7.5,
        },
        binary_points: 0,
    },
    continueTrading: {
        value: 'continue_trading',
        localization: { id: '', defaultMessage: '' },
        label: 'Maybe continue trading',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.bdSwissMauritius.key]: 1.5,
            [companies.bdSwissVanuatu.key]: 1.5,
            [companies.bdSwissSouthAfrica.key]: 1.5,
            [companies.bdSwissComoros.key]: 1.5,
            [companies.swissMarkets.key]: 3,
            [companies.swissMarketsMauritius.key]: 1.5,
            [companies.swissMarketsVanuatu.key]: 1.5,
        },
        binary_points: 0,
    },
    neverTradeAgain: {
        value: 'never_trade_again',
        localization: { id: '', defaultMessage: '' },
        label: 'Never trade again',
        forex_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        binary_points: 0,
    },
}));
const appropTestTinReason = generateLocalization('appropTestTinReason', generateKeys({
    noTinIssued: {
        value: 'no_tin_issued',
        localization: { id: '', defaultMessage: '' },
        label: 'TINs are not issued in my Tax Jurisdiction.',
    },
    unableToObtain: {
        value: 'unable_to_obtain',
        localization: { id: '', defaultMessage: '' },
        label: 'I\'m unable to obtain a TIN or equivalent number.',
    },
    noTinRequired: {
        value: 'no_tin_required',
        localization: { id: '', defaultMessage: '' },
        label: 'No TIN is required in my Tax Jurisdiction.',
    },
    iHaveTin: {
        value: 'i_have_tin',
        localization: { id: '', defaultMessage: '' },
        label: 'I have a TIN.',
    },
}));
const scoringResults = generateKeys({
    cannotTrade: {
        value: 'cannotTrade',
        maxDeposit: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: false,
            [companies.bdSwissVanuatu.key]: false,
            [companies.bdSwissSouthAfrica.key]: false,
            [companies.bdSwissComoros.key]: false,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: false,
            [companies.swissMarketsVanuatu.key]: false,
        },
        label: 'Level 1',
    },
    productNotSuitableLeverage50: {
        value: 'productNotSuitableLeverage50',
        leverage: {
            [companies.bdSwiss.key]: 30,
            [companies.bdSwissMauritius.key]: 50,
            [companies.bdSwissVanuatu.key]: 50,
            [companies.bdSwissSouthAfrica.key]: 50,
            [companies.bdSwissComoros.key]: 50,
            [companies.swissMarkets.key]: 30,
            [companies.swissMarketsMauritius.key]: 50,
            [companies.swissMarketsVanuatu.key]: 50,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 2',
    },
    productNotSuitableLeverage100: {
        value: 'productNotSuitableLeverage100',
        leverage: {
            [companies.bdSwiss.key]: 30,
            [companies.bdSwissMauritius.key]: 100,
            [companies.bdSwissVanuatu.key]: 100,
            [companies.bdSwissSouthAfrica.key]: 100,
            [companies.bdSwissComoros.key]: 100,
            [companies.swissMarkets.key]: 30,
            [companies.swissMarketsMauritius.key]: 100,
            [companies.swissMarketsVanuatu.key]: 100,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 3',
    },
    basicUnderstanding: {
        value: 'basicUnderstanding',
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 4',
    },
    advancedUnderstanding: {
        value: 'advancedUnderstanding',
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 5',
    },
});
const scoringResultsV2 = generateKeys({
    cannotTrade: {
        value: 'cannotTrade',
        maxDeposit: {
            [companies.bdSwiss.key]: 0,
            [companies.bdSwissMauritius.key]: 0,
            [companies.bdSwissVanuatu.key]: 0,
            [companies.bdSwissSouthAfrica.key]: 0,
            [companies.bdSwissComoros.key]: 0,
            [companies.swissMarkets.key]: 0,
            [companies.swissMarketsMauritius.key]: 0,
            [companies.swissMarketsVanuatu.key]: 0,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: false,
            [companies.bdSwissVanuatu.key]: false,
            [companies.bdSwissSouthAfrica.key]: false,
            [companies.bdSwissComoros.key]: false,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: false,
            [companies.swissMarketsVanuatu.key]: false,
        },
        label: 'Level 1',
    },
    productNotSuitableLeverage50: {
        value: 'productNotSuitableLeverage50',
        leverage: {
            [companies.bdSwiss.key]: 30,
            [companies.bdSwissMauritius.key]: 50,
            [companies.bdSwissVanuatu.key]: 50,
            [companies.bdSwissSouthAfrica.key]: 50,
            [companies.bdSwissComoros.key]: 50,
            [companies.swissMarkets.key]: 30,
            [companies.swissMarketsMauritius.key]: 50,
            [companies.swissMarketsVanuatu.key]: 50,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 2',
    },
    productNotSuitableLeverage100: {
        value: 'productNotSuitableLeverage100',
        leverage: {
            [companies.bdSwiss.key]: 30,
            [companies.bdSwissMauritius.key]: 100,
            [companies.bdSwissVanuatu.key]: 100,
            [companies.bdSwissSouthAfrica.key]: 100,
            [companies.bdSwissComoros.key]: 100,
            [companies.swissMarkets.key]: 30,
            [companies.swissMarketsMauritius.key]: 100,
            [companies.swissMarketsVanuatu.key]: 100,
        },
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 3',
    },
    advancedUnderstanding: {
        value: 'advancedUnderstanding',
        canEditLeverage: {
            [companies.bdSwiss.key]: false,
            [companies.bdSwissMauritius.key]: true,
            [companies.bdSwissVanuatu.key]: true,
            [companies.bdSwissSouthAfrica.key]: true,
            [companies.bdSwissComoros.key]: true,
            [companies.swissMarkets.key]: false,
            [companies.swissMarketsMauritius.key]: true,
            [companies.swissMarketsVanuatu.key]: true,
        },
        label: 'Level 5',
    },
});
const appropTestPoliticallyExposedReason = generateLocalization('appropTestPoliticallyExposedReason', generateKeys({
    directContact: {
        value: 'directContact',
        localization: { id: '', defaultMessage: '' },
        label: 'Are currently or have been entrusted (in the past 12 months) with prominent public functions (local or international)',
    },
    indirectContact: {
        value: 'indirectContact',
        localization: { id: '', defaultMessage: '' },
        label: 'Are closely connected either socially or professionally, to an individual who has been entrusted with prominent public functions (local or international)',
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None of the above apply to me',
    },
}));
const appropTestQuestions = generateLocalization('AptestQuestions', generateKeys({
    employmentStatus: {
        value: 'employmentStatus',
        localization: { id: '', defaultMessage: '' },
        order: 1,
        label: 'Employment Status',
        question: 'employmentStatusQuestion',
        options: getApplicableOptions(appropTestEmploymentStatus, 1),
        sectionTitle: 'personalDetailTitle',
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        dropdown: true,
    },
    educationLevel: {
        value: 'educationLevel',
        localization: { id: '', defaultMessage: '' },
        order: 2,
        label: 'Education Level',
        question: 'educationLevelQuestion',
        options: getApplicableOptions(appropTestEducationLevel, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
        relevant: () => true,
        disable: true,
    },
    annualIncome: {
        value: 'annualIncome',
        localization: { id: '', defaultMessage: '' },
        order: 3,
        label: 'Annual Income',
        question: 'annualIncomeQuestion',
        description: 'annualIncomeDesc',
        options: getApplicableOptions(appropTestAnnualIncome, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    netWorth: {
        value: 'netWorth',
        localization: { id: '', defaultMessage: '' },
        order: 4,
        label: 'Net Worth',
        question: 'netWorthQuestion',
        description: 'netWorthDesc',
        options: getApplicableOptions(appropTestNetWorth, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarkets, companies.swissMarketsMauritius, companies.bdSwissVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
        relevant: () => true,
        toggle: true,
    },
    sourceOfFunds: {
        value: 'sourceOfFunds',
        localization: { id: '', defaultMessage: '' },
        order: 5,
        label: 'What is the source of the Funds you wish to deposit?',
        question: 'sourceOfFundsQuestion',
        options: getApplicableOptions(appropTestSourceOfFunds, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        dropdown: true,
    },
    employerCategory: {
        value: 'employerCategory',
        localization: { id: '', defaultMessage: '' },
        order: 6,
        label: 'Employer Category',
        question: 'employerCategoryQuestion',
        options: getApplicableOptions(appropTestEmployerCategory, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        disable: true,
    },
    jobTitle: {
        value: 'jobTitle',
        localization: { id: '', defaultMessage: '' },
        order: 7,
        label: 'In what industry are you currently working in?',
        question: 'jobTitleQuestion',
        mandatory: (answers, field = 'value') => {
            const employmentEnum = appropTestSourceOfFunds.employment;
            return answers.sourceOfFunds === employmentEnum[field];
        },
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const employmentEnum = appropTestSourceOfFunds.employment;
            return answers.sourceOfFunds === employmentEnum[field];
        },
        textfield: true,
    },
    politicallyExposed: {
        value: 'politicallyExposed',
        localization: { id: '', defaultMessage: '' },
        order: 8,
        label: 'Are you a politically exposed person?',
        question: 'politicallyExposedQuestion',
        options: getApplicableOptions(appropTestPoliticallyExposed, 1),
        description: 'pepDesc',
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        alert: (value) => appropTestPoliticallyExposed.yes.label === value,
        relevant: () => true,
        toggle: true,
    },
    initialInvestment: {
        value: 'initialInvestment',
        localization: { id: '', defaultMessage: '' },
        order: 9,
        label: 'Initial Investment',
        question: 'initialInvestmentQuestion',
        options: getApplicableOptions(appropTestInitialInvestment, 1),
        sectionTitle: 'investmentTitle',
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    accountTurnover: {
        value: 'accountTurnover',
        localization: { id: '', defaultMessage: '' },
        order: 10,
        label: 'Estimated account turnover (yearly)?',
        question: 'accountTurnoverQuestion',
        options: getApplicableOptions(appropTestAccountTurnover, 1),
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    transactionPurpose: {
        value: 'transactionPurpose',
        localization: { id: '', defaultMessage: '' },
        order: 11,
        label: 'What is your intended purpose of transactions?',
        question: 'transactionPurposeQuestion',
        options: getApplicableOptions(appropTestTransactionPurpose, 1),
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        dropdown: true,
    },
    transactionNumber: {
        value: 'transactionNumber',
        localization: { id: '', defaultMessage: '' },
        order: 12,
        label: 'Transaction Number per month',
        question: 'transactionNumberQuestion',
        options: getApplicableOptions(appropTestTransactionNumber, 1),
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    haveTradingExperience: {
        value: 'haveTraingExperience',
        localization: { id: '', defaultMessage: '' },
        order: 13,
        label: 'Do you have experience related to financial trading?',
        question: 'appropHaveTradingExperience',
        options: getApplicableOptions(appropTestHaveTradingExperience, 1),
        sectionTitle: 'experienceTitle',
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    past2YearsProductsSwissMarkets: {
        value: 'past2YearsProductsSwissMarkets',
        localization: { id: '', defaultMessage: '' },
        order: 14,
        label: 'Over the past 2 years, which of these have you traded on:',
        question: 'appropPast2YearsProducts',
        options: getApplicableOptions(appropTestPast2YearsProductsSwMarkets, 1),
        multiselect: true,
        mandatory: (answers, field = 'value') => {
            const expField = appropTestHaveTradingExperience.yes;
            return answers.haveTradingExperience === expField[field];
        },
        company: [companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const expField = appropTestHaveTradingExperience.yes;
            return answers.haveTradingExperience === expField[field];
        },
    },
    past2YearsProductsBdswiss: {
        value: 'past2YearsProductsBdswiss',
        localization: { id: '', defaultMessage: '' },
        order: 15,
        label: 'Over the past 2 years, which of these have you traded on:',
        question: 'appropPast2YearsProducts',
        options: getApplicableOptions(appropTestPast2YearsProductsBdSwiss, 1),
        multiselect: true,
        mandatory: (answers, field = 'value') => {
            const expField = appropTestHaveTradingExperience.yes;
            return answers.haveTradingExperience === expField[field];
        },
        company: [companies.bdSwiss],
        relevant: (answers, field = 'value') => {
            const expField = appropTestHaveTradingExperience.yes;
            return answers.haveTradingExperience === expField[field];
        },
    },
    forexPast2YearsExperience: {
        value: 'forexPast2YearsExperience',
        localization: { id: '', defaultMessage: '' },
        order: 16,
        label: 'Forex trades per year:',
        question: 'appropForexPast2YearsExperience',
        options: getApplicableOptions(appropTestForexPast2YearsExperience, 1),
        toggle: true,
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => false,
    },
    binaryPast2YearsExperience: {
        value: 'binaryPast2YearsExperience',
        localization: { id: '', defaultMessage: '' },
        order: 17,
        label: 'Binary trades per year:',
        question: 'appropBinaryPast2YearsExperience',
        options: getApplicableOptions(appropTestBinaryPast2YearsExperience, 1),
        toggle: true,
        mandatory: () => false,
        company: [companies.bdSwiss],
        relevant: () => false,
    },
    financialDemoPast2YearsExperience: {
        value: 'financialDemoPast2YearsExperience',
        localization: { id: '', defaultMessage: '' },
        order: 18,
        label: 'Financial demo trades per year:',
        question: 'appropFinancialDemoPast2YearsExp',
        options: getApplicableOptions(appropTestFinancialDemoPast2YearsExp, 1),
        toggle: true,
        mandatory: () => false,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => false,
    },
    educatedInFinancialTrading: {
        value: 'educatedInFinancialTrading',
        localization: { id: '', defaultMessage: '' },
        order: 19,
        label: 'Do you have any education to help you understand financial trading?',
        question: 'appropEducatedInFinancialTrading',
        options: getApplicableOptions(appropTestEducatedInFinancialTrading, 1),
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    educationOptionInFinancialTrading: {
        value: 'educationOptionInFinancialTrading',
        localization: { id: '', defaultMessage: '' },
        order: 20,
        label: 'Education in financial services:',
        question: 'appropEducationOptionInFinancialTrading',
        options: getApplicableOptions(appropTestEducationOptionInFinancialTrading, 1),
        toggle: true,
        mandatory: (answers, field = 'value') => {
            const expField = appropTestEducatedInFinancialTrading.yes;
            return answers.educatedInFinancialTrading === expField[field];
        },
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const expField = appropTestEducatedInFinancialTrading.yes;
            return answers.educatedInFinancialTrading === expField[field];
        },
    },
    largerSizePositions: {
        value: 'largerSizePositions',
        localization: { id: '', defaultMessage: '' },
        order: 22,
        label: `Trading with a higher leverage in Forex/CFDs means that, with the same equity amount you are able to
      open a larger sized position, thus increasing the possible losses as well as possible gains.`,
        question: 'appropLargerSizePositions',
        options: getApplicableOptions(appropTestLargerSizePositions, 1),
        sectionTitle: 'knowladgeDemostrationTittle',
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    lostInvestment: {
        value: 'lostInvestment',
        localization: { id: '', defaultMessage: '' },
        order: 23,
        label: `You have invested €500 to buy a call Binary Option on EUR/USD. At expiration of the option,
      if the price of EUR/USD is lower than my entry price my investment will be completely lost.`,
        question: 'appropLostInvestment',
        options: getApplicableOptions(appropTestLostInvestment, 1),
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss],
        relevant: () => true,
    },
    volatileMarkets: {
        value: 'volatileMarkets',
        localization: { id: '', defaultMessage: '' },
        order: 24,
        label: `During news events from around the world the markets can be much more volatile. This may
      cause an order to be executed at a more favourable or less favourable price than was original expected.`,
        question: 'appropVolatileMarkets',
        options: getApplicableOptions(appropTestVolatileMarkets, 1),
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    relevantProfession: {
        value: 'relevantProfession',
        localization: { id: '', defaultMessage: '' },
        order: 25,
        label: 'Relevant Profession',
        question: 'relevantProfessionQuestion',
        options: getApplicableOptions(appropTestRelevantProfession, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    relevantQualificationsOrExperience: {
        value: 'relevantQualificationsOrExperience',
        localization: { id: '', defaultMessage: '' },
        order: 26,
        label: 'Relevant Qualifications or Experience',
        question: 'relevantQualificationsOrExperienceQuestion',
        disable: true,
        options: getApplicableOptions(appropTestRelevantQualOrExp, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    riskUnderstanding: {
        value: 'riskUnderstanding',
        localization: { id: '', defaultMessage: '' },
        order: 27,
        label: 'Risk understanding',
        question: 'riskUnderstandingQuestion',
        options: getApplicableOptions(appropTestRiskUnderstanding, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    attendedSeminarOrCourseForex: {
        value: 'attendedSeminarOrCourseForex',
        localization: { id: '', defaultMessage: '' },
        order: 28,
        label: 'Attended Seminar or Course in Forex',
        question: 'attendedSeminarOrCourseForexQuestion',
        options: getApplicableOptions(appropTestAttendedSeminarOrCourseForex, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
    attendedSeminarOrCourseBinary: {
        value: 'attendedSeminarOrCourseBinary',
        localization: { id: '', defaultMessage: '' },
        order: 29,
        label: 'Attended Seminar or Course in Binary',
        question: 'attendedSeminarOrCourseBinaryQuestion',
        options: getApplicableOptions(appropTestAttendedSeminarOrCourseBinary, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.bdSwiss],
        relevant: () => true,
    },
    haveTraded: {
        value: 'haveTraded',
        localization: { id: '', defaultMessage: '' },
        order: 30,
        label: 'Have Traded',
        question: 'haveTradedQuestion',
        options: getApplicableOptions(appropTestHaveTraded, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.bdSwiss],
        relevant: () => true,
    },
    haveTradedForexCfd: {
        value: 'haveTradedForexCfd',
        localization: { id: '', defaultMessage: '' },
        order: 31,
        label: 'Have Traded Forex and/or CFD',
        question: 'haveTradedForexCfdQuestion',
        options: getApplicableOptions(appropTestHaveTraded, 1),
        disable: true,
        mandatory: () => true,
        company: [companies.swissMarkets],
        relevant: () => true,
    },
    tradingExperienceForex: {
        value: 'tradingExperienceForex',
        localization: { id: '', defaultMessage: '' },
        order: 32,
        label: 'Forex trading experience in years',
        question: 'tradingExperienceForexQuestion',
        options: getApplicableOptions(appropTestTradingExperienceForex, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
        company: [companies.swissMarkets, companies.bdSwiss],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
    },
    tradingExperienceSharesBonds: {
        value: 'tradingExperienceSharesBonds',
        localization: { id: '', defaultMessage: '' },
        order: 33,
        label: 'Shares Bonds trading experience in years',
        question: 'tradingExperienceSharesBondsQuestion',
        options: getApplicableOptions(appropTestTradingExperienceSharesBonds, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
        company: [companies.swissMarkets, companies.bdSwiss],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
    },
    tradingExperienceExchange: {
        value: 'tradingExperienceExchange',
        localization: { id: '', defaultMessage: '' },
        order: 34,
        label: 'Exchange - Traded Derivatives trading experience in years',
        question: 'tradingExperienceExchangeQuestion',
        options: getApplicableOptions(appropTestTradingExperienceExchange, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
        company: [companies.swissMarkets, companies.bdSwiss],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field] || answers.haveTradedForexCfd === haveTradedYes[field];
        },
    },
    tradingExperienceOTC: {
        value: 'tradingExperienceOTC',
        localization: { id: '', defaultMessage: '' },
        order: 35,
        label: 'OTC Derivatives - Excluding Binary trading experience in years',
        question: 'tradingExperienceOTCQuestion',
        options: getApplicableOptions(appropTestTradingExperienceOTC, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
        company: [companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
    },
    tradingExperienceOTCSwissmarkets: {
        value: 'tradingExperienceOTCSwissmarkets',
        localization: { id: '', defaultMessage: '' },
        order: 36,
        label: 'OTC Derivatives trading experience',
        question: 'tradingExperienceOTCSwissmarketsQuestion',
        options: getApplicableOptions(appropTestTradingExperienceOTC, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTradedForexCfd === haveTradedYes[field];
        },
        company: [companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTradedForexCfd === haveTradedYes[field];
        },
    },
    tradingExperienceBinary: {
        value: 'tradingExperienceBinary',
        localization: { id: '', defaultMessage: '' },
        order: 37,
        label: 'Binary trading experience in years',
        question: 'tradingExperienceBinaryQuestion',
        options: getApplicableOptions(appropTestTradingExperienceBinary, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
        company: [companies.bdSwiss],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
    },
    tradingFrequencyLast12Months: {
        value: 'tradingFrequencyLast12Months',
        localization: { id: '', defaultMessage: '' },
        order: 38,
        label: 'Trading Frequency the last 12 months',
        question: 'tradingFrequency12MonthsQuestion',
        options: getApplicableOptions(appropTestTradingFrequency12Months, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
    },
    tradingTransactionsLast12Months: {
        value: 'tradingTransactionsLast12Months',
        localization: { id: '', defaultMessage: '' },
        order: 39,
        label: 'Trading Transactions the last 12 months in USD',
        question: 'tradingTransactionsLast12MonthsQuestion',
        options: getApplicableOptions(appropTestTradingTransactions12Months, 1),
        disable: true,
        mandatory: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const haveTradedYes = appropTestHaveTraded.yes;
            return answers.haveTraded === haveTradedYes[field];
        },
    },
    isUsReportable: {
        value: 'isUsReportable',
        localization: { id: '', defaultMessage: '' },
        order: 40,
        label: 'US Reportable',
        question: 'isUsReportableQuestion',
        sectionTitle: 'usTitle',
        options: getApplicableOptions(appropTestIsUsReportable, 1),
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    usTaxId: {
        value: 'usTaxId',
        localization: { id: '', defaultMessage: '' },
        order: 41,
        label: 'US Tax Id',
        question: 'usTaxIdQuestion',
        mandatory: (answers, field = 'value') => {
            const usReportableYes = appropTestIsUsReportable.yes;
            return answers.isUsReportable === usReportableYes[field];
        },
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: (answers, field = 'value') => {
            const usReportableYes = appropTestIsUsReportable.yes;
            return answers.isUsReportable === usReportableYes[field];
        },
        textfield: true,
    },
    acknowledgmentConfirmation: {
        value: 'acknowledgmentConfirmation',
        localization: { id: '', defaultMessage: '' },
        order: 42,
        label: 'Acknowledgment confirmation',
        question: 'acknowledgmentConfirmationQuestion',
        options: getApplicableOptions(appropTestAcknowledgmentAcceptance, 1),
        sectionTitle: 'declarationTitle',
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
        toggle: true,
    },
    expectedDeposit: {
        value: 'expectedDeposit',
        localization: { id: '', defaultMessage: '' },
        order: 43,
        label: 'Expected Deposit',
        question: 'expectedDepositQuestion',
        options: getApplicableOptions(appropTestExpectedDeposit, 1),
        relevant: () => false,
        mandatory: () => false,
        disable: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    howManyTimesHaveTraded: {
        value: 'howManyTimesHaveTraded',
        localization: { id: '', defaultMessage: '' },
        order: 44,
        label: 'How Many Times Have Traded',
        question: 'howManyTimesHaveTradedQuestion',
        options: getApplicableOptions(appropTestHowManyTimesHaveTraded, 1),
        relevant: () => false,
        mandatory: () => false,
        disable: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    attendedSeminarOrCourse: {
        value: 'attendedSeminarOrCourse',
        localization: { id: '', defaultMessage: '' },
        order: 45,
        label: 'Attended Seminar or Course',
        question: 'attendedSeminarOrCourseQuestion',
        sectionTitle: 'educationTitle',
        options: getApplicableOptions(appropTestAttendedSeminarOrCourse, 1),
        relevant: () => false,
        mandatory: () => false,
        disable: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    appropriatenessWarning: {
        value: 'appropriatenessWarning',
        localization: { id: '', defaultMessage: '' },
        order: 46,
        label: 'Warning',
        question: 'appropWarning',
        options: getApplicableOptions(appropTestWarningAcceptance, 1),
        toggle: true,
        mandatory: () => true,
        company: [companies.bdSwiss, companies.swissMarkets],
        relevant: () => true,
    },
}));
const mainTradingPurposeOptions = generateLocalization('mainTradingPurposeOptions', generateKeys({
    intradayTrading: {
        value: 'intraday_trading',
        localization: { id: '', defaultMessage: '' },
        label: 'Intraday trading',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    shortTermInvestments: {
        value: 'short_term_investments',
        localization: { id: '', defaultMessage: '' },
        label: 'Short-term investments',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    speculation: {
        value: 'speculation',
        localization: { id: '', defaultMessage: '' },
        label: 'Speculation',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    hedging: {
        value: 'hedging',
        localization: { id: '', defaultMessage: '' },
        label: 'Hedging of exposure to an underlying asset',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    investmentPortfolioDiversification: {
        value: 'investment_portfolio_diversification',
        localization: { id: '', defaultMessage: '' },
        label: 'Investment portfolio diversification',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    buyAndHoldInvestment: {
        value: 'buy_and_hold_investment',
        localization: { id: '', defaultMessage: '' },
        label: 'Buy and Hold Investment',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    capitalPreservation: {
        value: 'capital_preservation',
        localization: { id: '', defaultMessage: '' },
        label: 'Capital preservation',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const moneyForTradingOptions = generateLocalization('moneyForTradingOptions', generateKeys({
    all: {
        value: 'all',
        localization: { id: '', defaultMessage: '' },
        label: 'All of it. I am a risk taker.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    most: {
        value: 'most',
        localization: { id: '', defaultMessage: '' },
        label: 'Most of it. I am willing to assume substantial risk.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    some: {
        value: 'some',
        localization: { id: '', defaultMessage: '' },
        label: 'Some of it. I am willing to assume moderate risk.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None. I cannot accept losing any money from trading in CFDs.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const lengthOfInvestmentOptions = generateLocalization('lengthOfInvestmentOptions', generateKeys({
    day: {
        value: 'day',
        localization: { id: '', defaultMessage: '' },
        label: 'For day trading.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    less: {
        value: 'less',
        localization: { id: '', defaultMessage: '' },
        label: 'Less than a month.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    oneToTheeMonths: {
        value: 'one_to_thee_months',
        localization: { id: '', defaultMessage: '' },
        label: 'Between 1 to 3 months.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    threeToSixMonths: {
        value: 'three_to_six_months',
        localization: { id: '', defaultMessage: '' },
        label: 'Between 3 to 6 months.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    sixToTwelveMonths: {
        value: 'six_to_twelve_months',
        localization: { id: '', defaultMessage: '' },
        label: 'Between 6 months to 1 year.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    moreThanYear: {
        value: 'moreThanYear',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 1 year.',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const levelOfEducationOptions = generateLocalization('levelOfEducationOptions', generateKeys({
    secondary: {
        value: 'secondary',
        localization: { id: '', defaultMessage: '' },
        label: 'Secondary (High School)',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    bachelor: {
        value: 'bachelor',
        localization: { id: '', defaultMessage: '' },
        label: 'Bachelor\'s Degree or equivalent',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    master: {
        value: 'master',
        localization: { id: '', defaultMessage: '' },
        label: 'Master\'s Degree or equivalent',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.swissMarkets.key]: 3,
        },
    },
    doctorate: {
        value: 'doctorate',
        localization: { id: '', defaultMessage: '' },
        label: 'Doctorate',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    none: {
        value: 'none',
        localization: { id: '', defaultMessage: '' },
        label: 'None of the above',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const employmentOptions = generateLocalization('employmentOptions', generateKeys({
    employed: {
        value: 'employed',
        localization: { id: '', defaultMessage: '' },
        label: 'Employed',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    unemployed: {
        value: 'unemployed',
        localization: { id: '', defaultMessage: '' },
        label: 'Unemployed',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    selfEmployed: {
        value: 'self_employed',
        localization: { id: '', defaultMessage: '' },
        label: 'Self-Employed',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    retired: {
        value: 'retired',
        localization: { id: '', defaultMessage: '' },
        label: 'Retired',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const natureOfProfessionOptions = generateLocalization('natureOfProfessionOptions', generateKeys({
    financialServices: {
        value: 'financial_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Financial Services',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.swissMarkets.key]: 6,
        },
    },
    legalServices: {
        value: 'legal_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Legal Services',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    accountingServices: {
        value: 'accounting_services',
        localization: { id: '', defaultMessage: '' },
        label: 'Accounting Services',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 4,
            [companies.swissMarkets.key]: 4,
        },
    },
    it: {
        value: 'it',
        localization: { id: '', defaultMessage: '' },
        label: 'IT',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    governmentActivites: {
        value: 'government_activites',
        localization: { id: '', defaultMessage: '' },
        label: 'Government Activities',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    computersMathematics: {
        value: 'computers_mathematics',
        localization: { id: '', defaultMessage: '' },
        label: 'Computers and/or Mathematics',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2,
            [companies.swissMarkets.key]: 2,
        },
    },
    education: {
        value: 'education',
        localization: { id: '', defaultMessage: '' },
        label: 'Education',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    educatengineeringConstructionion: {
        value: 'engineering_construction',
        localization: { id: '', defaultMessage: '' },
        label: 'Engineering and/or Construction',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    other: {
        value: 'other',
        localization: { id: '', defaultMessage: '' },
        label: 'Other',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const tradesVolumeOptions = generateLocalization('tradesVolumeOptions', generateKeys({
    moreThanFirty: {
        value: 'more_than_firty',
        localization: { id: '', defaultMessage: '' },
        label: 'more than 50 times',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.swissMarkets.key]: 6,
        },
    },
    twentyToFifty: {
        value: 'twenty_to_fifty',
        localization: { id: '', defaultMessage: '' },
        label: '20 to 50 times',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    upToTwenty: {
        value: 'up_to_twenty',
        localization: { id: '', defaultMessage: '' },
        label: 'up to 20 times',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2,
            [companies.swissMarkets.key]: 2,
        },
    },
    never: {
        value: 'never',
        localization: { id: '', defaultMessage: '' },
        label: 'Never',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const sizePerTransactionOptions = generateLocalization('sizePerTransactionOptions', generateKeys({
    zeroLessThanThousand: {
        value: 'zeroLessThanThousand',
        localization: { id: '', defaultMessage: '' },
        label: 'below 1,000',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1,
            [companies.swissMarkets.key]: 1,
        },
    },
    thousandToTenThousand: {
        value: 'thousand_to_ten_thousand',
        localization: { id: '', defaultMessage: '' },
        label: 'between 1,000-10,000',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 2,
            [companies.swissMarkets.key]: 2,
        },
    },
    tenThousandToHundredThousand: {
        value: 'ten_thousand_to_ten_thousand',
        localization: { id: '', defaultMessage: '' },
        label: 'between 10,000-100,000',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    moreThanHundredThousand: {
        value: 'more_than_hundred_thousand',
        localization: { id: '', defaultMessage: '' },
        label: '100,000+',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 6,
            [companies.swissMarkets.key]: 6,
        },
    },
}));
const periodOfExecutionsOptions = generateLocalization('periodOfExecutionsOptions', generateKeys({
    inTheLastYear: {
        value: 'in_the_last_year',
        localization: { id: '', defaultMessage: '' },
        label: 'In the last Year',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    inTheLastTwoThreeYears: {
        value: 'in_the_last_two_three_years',
        localization: { id: '', defaultMessage: '' },
        label: 'In the last 2-3 years',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    moreThanThreeYearsAgo: {
        value: 'more_than_three_years_ago',
        localization: { id: '', defaultMessage: '' },
        label: 'More than 3 years ago',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 1,
            [companies.swissMarkets.key]: 1,
        },
    },
    never: {
        value: 'never',
        localization: { id: '', defaultMessage: '' },
        label: 'Never',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const placingSellLimitOptions = generateLocalization('placingSellLimitOptions', generateKeys({
    openSellPositionPriceRequested: {
        value: 'open_sell_position_price_requested',
        localization: { id: '', defaultMessage: '' },
        label: 'To open a Sell position at the price you requested, which is higher than the current market price',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    openBuyPositionPriceRequested: {
        value: 'open_buy_position_price_requested',
        localization: { id: '', defaultMessage: '' },
        label: 'To open a Buy position at the price you requested, which is Lower than the current market price',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    openSellPositionInstantly: {
        value: 'open_sell_position_instantly',
        localization: { id: '', defaultMessage: '' },
        label: 'To open a Sell position instantly and at the current market price',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const sellShortPositionOptions = generateLocalization('sellShortPositionOptions', generateKeys({
    closedAtProfit: {
        value: 'closed_at_profit',
        localization: { id: '', defaultMessage: '' },
        label: 'Was closed at a profit',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    closedAtLoss: {
        value: 'closed_at_loss',
        localization: { id: '', defaultMessage: '' },
        label: 'Was closed at a loss',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    closedAutomatically: {
        value: 'closed_automatically',
        localization: { id: '', defaultMessage: '' },
        label: 'Was closed automatically due to reaching the Take Profit level',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const largerPositionOptions = generateLocalization('largerPositionOptions', generateKeys({
    lossWillIncrease: {
        value: 'loss_will_increase',
        localization: { id: '', defaultMessage: '' },
        label: 'My risk of loss will increase',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    lossWillDecrease: {
        value: 'loss_will_decrease',
        localization: { id: '', defaultMessage: '' },
        label: 'My risk of loss will decrease',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    noChange: {
        value: 'no_change',
        localization: { id: '', defaultMessage: '' },
        label: 'No change to my risk of loss',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const requiredMarginOptions = generateLocalization('requiredMarginOptions', generateKeys({
    nineThousands: {
        value: 'nine_thousands',
        localization: { id: '', defaultMessage: '' },
        label: '9,000 EUR',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    fiveMillions: {
        value: 'five_millions',
        localization: { id: '', defaultMessage: '' },
        label: '5,000,000 EUR',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    threeThousandThirtyThree: {
        value: 'three_thousand_thirty_three',
        localization: { id: '', defaultMessage: '' },
        label: '3,333 EUR',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    twelveThousands: {
        value: 'twelve_thousands',
        localization: { id: '', defaultMessage: '' },
        label: '12,000 EUR',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const closingOrderOptions = generateLocalization('closingOrderOptions', generateKeys({
    takeProfitOrder: {
        value: 'take_profit_order',
        localization: { id: '', defaultMessage: '' },
        label: 'A take profit order',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    stopLossOrder: {
        value: 'stop_loss_order',
        localization: { id: '', defaultMessage: '' },
        label: 'A stop loss order',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    noOrder: {
        value: 'no_order',
        localization: { id: '', defaultMessage: '' },
        label: 'No such order exists',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const leverageLeadOptions = generateLocalization('leverageLeadOptions', generateKeys({
    oneThirty: {
        value: 'one_thirty',
        localization: { id: '', defaultMessage: '' },
        label: '1:30',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 10,
            [companies.swissMarkets.key]: 10,
        },
    },
    oneTen: {
        value: 'one_ten',
        localization: { id: '', defaultMessage: '' },
        label: '1:10',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    oneFive: {
        value: 'one_five',
        localization: { id: '', defaultMessage: '' },
        label: '1:5',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
    dontKnow: {
        value: 'dont_know',
        localization: { id: '', defaultMessage: '' },
        label: 'I don\'t know the answer',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const priorExperienceOptions = generateLocalization('priorExperienceOptions', generateKeys({
    oneYearWithDegree: {
        value: 'one_year_with_degree',
        localization: { id: '', defaultMessage: '' },
        label: 'Yes, I have at least one year of relevant trading experience and hold a relevant degree',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 7,
            [companies.swissMarkets.key]: 7,
        },
    },
    oneYearWithExperience: {
        value: 'one_year_with_experience',
        localization: { id: '', defaultMessage: '' },
        label: 'I have at least one year trading experience',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 5,
            [companies.swissMarkets.key]: 5,
        },
    },
    relevantDegree: {
        value: 'relevant_degree',
        localization: { id: '', defaultMessage: '' },
        label: 'I hold relevant degree',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 3,
            [companies.swissMarkets.key]: 3,
        },
    },
    noTradingExperience: {
        value: 'no_trading_experience',
        localization: { id: '', defaultMessage: '' },
        label: 'I have no relevant trading experience and no relevant degree',
        forex_points: 0,
        binary_points: 0,
        forex_points_v2: {
            [companies.bdSwiss.key]: 0,
            [companies.swissMarkets.key]: 0,
        },
    },
}));
const appropTestQuestionsV2 = generateLocalization('AptestQuestionsV2', generateKeys({
    educationLevelV2: {
        value: 'educationLevelV2',
        localization: { id: '', defaultMessage: '' },
        order: 1,
        orderLabel: () => 1,
        label: 'What is your level of education?',
        step: apTestSteps.knowledgeDemonstation,
        sectionTitle: 'knowladgeDemostrationTittle',
        question: 'appropEducationLevel',
        options: getApplicableOptions(appropTestEducationLevel, 2),
        mandatory: () => true,
        company: [],
        relevant: () => true,
        dropdown: true,
    },
    professionStatusV2: {
        value: 'professionStatusV2',
        localization: { id: '', defaultMessage: '' },
        order: 1,
        orderLabel: () => 1,
        label: 'What is your current profession status field?',
        step: apTestSteps.knowledgeDemonstation,
        sectionTitle: 'knowladgeDemostrationTittle',
        question: 'appropProfessionStatus',
        options: getApplicableOptions(appropTestProfessionStatus, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwissMauritius, companies.swissMarketsMauritius, companies.bdSwissVanuatu, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
    },
    fieldOfStudyV2: {
        value: 'fieldOfStudyV2',
        localization: { id: '', defaultMessage: '' },
        order: 2,
        orderLabel: () => 1.1,
        step: apTestSteps.knowledgeDemonstation,
        label: 'What is your field of study?',
        question: 'appropFieldOfStudy',
        options: getApplicableOptions(appropTestFieldOfStudy, 2),
        mandatory: (answers, field = 'value') => {
            const proQualification = appropTestEducationLevel.professionalQualification;
            const uniQualification = appropTestEducationLevel.universityCollege;
            const secQualification = appropTestEducationLevel.secondaryEducation;
            return (answers.educationLevelV2 === proQualification[field] ||
                answers.educationLevelV2 === uniQualification[field] ||
                answers.educationLevelV2 === secQualification[field]);
        },
        relevant: (answers, field = 'value') => {
            const proQualification = appropTestEducationLevel.professionalQualification;
            const uniQualification = appropTestEducationLevel.universityCollege;
            const secQualification = appropTestEducationLevel.secondaryEducation;
            return (answers.educationLevelV2 === proQualification[field] ||
                answers.educationLevelV2 === uniQualification[field] ||
                answers.educationLevelV2 === secQualification[field]);
        },
        dropdown: true,
        company: [],
    },
    transactionPurposeV2: {
        value: 'transactionPurposeV2',
        localization: { id: '', defaultMessage: '' },
        order: 3,
        orderLabel: () => 2,
        step: apTestSteps.knowledgeDemonstation,
        label: 'What is your intended purpose of transactions?',
        question: 'transactionPurposeQuestion',
        options: getApplicableOptions(appropTestTransactionPurpose, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
    },
    ifLoseCapitalV2: {
        value: 'ifLoseCapitalV2',
        localization: { id: '', defaultMessage: '' },
        order: 4,
        orderLabel: () => 3,
        step: apTestSteps.knowledgeDemonstation,
        label: 'Assume that you can meet your financial obligations even if you lose your deposited capital. How would you react if you lose that amount after trading FX or CFDs?',
        question: 'appropIfLoseCapital',
        options: getApplicableOptions(appropTestIfLoseCapital, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
    },
    netWorthV2: {
        value: 'netWorthV2',
        localization: { id: '', defaultMessage: '' },
        order: 5,
        orderLabel: () => 4,
        step: apTestSteps.financialSituation,
        label: 'What is your approximate total net worth in Euro?',
        sectionTitle: 'financialSituationTitle',
        question: 'netWorthQuestion',
        description: 'netWorthDesc',
        options: getApplicableOptions(appropTestNetWorth, 2),
        mandatory: () => true,
        relevant: () => true,
        toggle: true,
        company: [],
    },
    disposableIncomeV2: {
        value: 'disposableIncomeV2',
        localization: { id: '', defaultMessage: '' },
        order: 6,
        orderLabel: (company) => {
            return company && includes([companies.bdSwissMauritius.value, companies.bdSwissVanuatu.value,
                companies.swissMarketsMauritius.value, companies.swissMarketsVanuatu.value,
                companies.bdSwissSouthAfrica.value, companies.bdSwissComoros.value], company) ? 4 : 5;
        },
        step: apTestSteps.financialSituation,
        label: 'What is your disposable income (income-expenses) per month in Euro?',
        question: 'appropDisposableIncome',
        options: getApplicableOptions(appropTestDisposableIncome, 2),
        mandatory: () => true,
        relevant: () => true,
        toggle: true,
        dropdown: true,
        company: [companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
    },
    initialInvestmentV2: {
        value: 'initialInvestmentV2',
        localization: { id: '', defaultMessage: '' },
        order: 7,
        orderLabel: () => 6,
        step: apTestSteps.financialSituation,
        label: 'What is your planned initial investment in Euro?',
        question: 'initialInvestmentQuestion',
        options: getApplicableOptions(appropTestInitialInvestment, 2),
        description: 'initialInvestmentDesc',
        mandatory: () => true,
        relevant: () => true,
        toggle: true,
        company: [],
    },
    past2YearsTradingExperienceV2: {
        value: 'past2YearsTradingExperienceV2',
        localization: { id: '', defaultMessage: '' },
        order: 8,
        orderLabel: (company) => {
            return company && includes([companies.bdSwissMauritius.value, companies.bdSwissVanuatu.value,
                companies.swissMarketsMauritius.value, companies.swissMarketsVanuatu.value,
                companies.bdSwissSouthAfrica.value, companies.bdSwissComoros.value], company) ? 5 : 7;
        },
        step: apTestSteps.personalExperience,
        sectionTitle: 'experienceTitle',
        label: 'In the past 2 years I have traded',
        question: 'appropTradingExperience',
        options: getApplicableOptions(appropTestPast2YearsTradingExperience, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwissMauritius, companies.bdSwissVanuatu,
            companies.swissMarketsMauritius, companies.swissMarketsVanuatu,
            companies.bdSwissSouthAfrica, companies.bdSwissComoros],
    },
    transactionsInForexV2: {
        value: 'transactionsInForexV2',
        localization: { id: '', defaultMessage: '' },
        order: 9,
        orderLabel: () => 7.1,
        step: apTestSteps.personalExperience,
        label: 'In the past 2 years what was the total volume of your transactions in Forex?',
        question: 'appropTransactionsInForex',
        options: getApplicableOptions(appropTestTransactionsInForex, 2),
        mandatory: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        relevant: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        toggle: true,
        company: [],
    },
    transactionsInCommoditiesV2: {
        value: 'transactionsInCommoditiesV2',
        localization: { id: '', defaultMessage: '' },
        order: 10,
        orderLabel: () => 7.2,
        step: apTestSteps.personalExperience,
        label: 'In the past 2 years what was the total volume of your transactions of Commodities or Shares or Bonds or Indices?',
        question: 'appropTransactionsInCommodities',
        options: getApplicableOptions(appropTestTransactionsInCommodities, 2),
        mandatory: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        relevant: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        toggle: true,
        company: [],
    },
    withLeverageForexV2: {
        value: 'withLeverageForexV2',
        localization: { id: '', defaultMessage: '' },
        order: 11,
        orderLabel: () => 7.3,
        step: apTestSteps.personalExperience,
        label: 'In the past 2 years how many times have you traded in Forex with leverage?',
        question: 'appropWithLeverageForex',
        options: getApplicableOptions(appropTestWithLeverageForex, 2),
        mandatory: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        relevant: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        toggle: true,
        company: [],
    },
    withLeverageCommoditiesV2: {
        value: 'withLeverageCommoditiesV2',
        localization: { id: '', defaultMessage: '' },
        order: 12,
        orderLabel: () => 7.4,
        step: apTestSteps.personalExperience,
        label: 'In the past 2 years how many times have you traded Commodities or Shares or Bonds or Indices with leverage?',
        question: 'appropWithLeverageCommodities',
        options: getApplicableOptions(appropTestWithLeverageCommodities, 2),
        mandatory: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        relevant: (answers, field = 'value') => {
            const notTraded = appropTestPast2YearsTradingExperience.notTraded;
            return answers.past2YearsTradingExperienceV2 !== notTraded[field] &&
                answers.past2YearsTradingExperienceV2 !== '';
        },
        toggle: true,
        company: [],
    },
    stockDropsV2: {
        value: 'stockDropsV2',
        localization: { id: '', defaultMessage: '' },
        order: 13,
        orderLabel: () => 8,
        step: apTestSteps.personalExperience,
        label: 'What will happen to the price of your APPLE CFD if the APPLE stock that is traded on the NASDAQ exchange drops significantly?',
        question: 'appropStockDrops',
        options: getApplicableOptions(appropTestStockDrops, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [],
    },
    buyFacebookCfdV2: {
        value: 'buyFacebookCfdV2',
        localization: { id: '', defaultMessage: '' },
        order: 14,
        orderLabel: () => 9,
        step: apTestSteps.personalExperience,
        label: 'If you buy a Facebook CFD through the {{domain}} platform where can you sell it in the future?',
        question: 'appropBuyFacebookCfd',
        options: getApplicableOptions(appropTestBuyFacebookCfd, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [],
    },
    maximumPositionV2: {
        value: 'maximumPositionV2',
        localization: { id: '', defaultMessage: '' },
        order: 15,
        orderLabel: () => 10,
        step: apTestSteps.personalExperience,
        label: 'If you want to trade with 1:30 leverage and you have in your account €1,000 what is the maximum position you can open?',
        question: 'appropMaximumPosition',
        options: getApplicableOptions(appropTestMaximumPosition, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [],
    },
    tradingWithLeverageV2: {
        value: 'tradingWithLeverageV2',
        localization: { id: '', defaultMessage: '' },
        order: 16,
        orderLabel: () => 11,
        step: apTestSteps.personalExperience,
        label: 'When trading with Leverage which one of the following applies:',
        question: 'appropTradingWithLeverage',
        options: getApplicableOptions(appropTestTradingWithLeverage, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [],
    },
    cfdTradingV2: {
        value: 'cfdTradingV2',
        localization: { id: '', defaultMessage: '' },
        order: 17,
        orderLabel: () => 12,
        step: apTestSteps.personalExperience,
        label: 'Which of the following statements is correct regarding CFD trading?',
        question: 'appropCfdTrading',
        options: getApplicableOptions(appropTestCfdTrading, 2),
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [],
    },
    mainTradingPurpose: {
        value: 'mainTradingPurpose',
        localization: { id: '', defaultMessage: '' },
        order: 18,
        orderLabel: () => 1,
        step: apTestSteps.knowledgeDemonstation,
        label: 'What is your main trading purpose?',
        question: 'mainTradingPurposeQuestion',
        options: mainTradingPurposeOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    moneyForTrading: {
        value: 'moneyForTrading',
        localization: { id: '', defaultMessage: '' },
        order: 19,
        orderLabel: () => 2,
        step: apTestSteps.knowledgeDemonstation,
        label: 'How much of your money to be used for trading in Contracts for Differences (CFDs) can you accept to risk losing?',
        question: 'moneyForTradingQuestion',
        options: moneyForTradingOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    lengthOfInvestment: {
        value: 'lengthOfInvestment',
        localization: { id: '', defaultMessage: '' },
        order: 20,
        orderLabel: () => 3,
        step: apTestSteps.knowledgeDemonstation,
        label: 'What is the length of time you wish to hold the investment?',
        question: 'lengthOfInvestmentQuestion',
        options: lengthOfInvestmentOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    levelOfEducation: {
        value: 'levelOfEducation',
        localization: { id: '', defaultMessage: '' },
        order: 21,
        orderLabel: () => 4,
        step: apTestSteps.financialSituation,
        label: 'What is your Level of Education?',
        question: 'levelOfEducationQuestion',
        options: levelOfEducationOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    employment: {
        value: 'employment',
        localization: { id: '', defaultMessage: '' },
        order: 22,
        orderLabel: () => 5,
        step: apTestSteps.financialSituation,
        label: 'What is your Employment Status?',
        question: 'employmentQuestion',
        options: employmentOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    natureOfProfession: {
        value: 'natureOfProfession',
        localization: { id: '', defaultMessage: '' },
        order: 23,
        orderLabel: () => 6,
        step: apTestSteps.financialSituation,
        label: 'What is the nature of your profession/business or relevant former profession/business?',
        question: 'natureOfProfessionQuestion',
        options: natureOfProfessionOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    tradesVolume: {
        value: 'tradesVolume',
        localization: { id: '', defaultMessage: '' },
        order: 24,
        orderLabel: () => 7,
        step: apTestSteps.financialSituation,
        label: 'How many trades have you executed in the following instruments? Exchange Traded Derivatives (e.g. CFDs, Warrants, Futures, Options)',
        question: 'tradesVolumeQuestion',
        options: tradesVolumeOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    sizePerTransaction: {
        value: 'sizePerTransaction',
        localization: { id: '', defaultMessage: '' },
        order: 25,
        orderLabel: () => 8,
        step: apTestSteps.financialSituation,
        label: 'Average size per transaction (currency units):',
        question: 'sizePerTransactionQuestion',
        options: sizePerTransactionOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    periodOfExecutions: {
        value: 'periodOfExecutions',
        localization: { id: '', defaultMessage: '' },
        order: 26,
        orderLabel: () => 9,
        step: apTestSteps.financialSituation,
        label: 'Over what period did you execute these trades?',
        question: 'periodOfExecutionsQuestion',
        options: periodOfExecutionsOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    placingSellLimit: {
        value: 'placingSellLimit',
        localization: { id: '', defaultMessage: '' },
        order: 27,
        orderLabel: () => 10,
        step: apTestSteps.financialSituation,
        label: 'When placing the Sell Limit type of pending order, you are telling your broker:',
        question: 'placingSellLimitQuestion',
        options: placingSellLimitOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    sellShortPosition: {
        value: 'sellShortPosition',
        localization: { id: '', defaultMessage: '' },
        order: 28,
        orderLabel: () => 11,
        step: apTestSteps.personalExperience,
        label: 'A Sell/Short position on EUR/USD has closed at a higher price than it was opened. This position:',
        question: 'sellShortPositionQuestion',
        options: sellShortPositionOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    largerPosition: {
        value: 'largerPosition',
        localization: { id: '', defaultMessage: '' },
        order: 29,
        orderLabel: () => 12,
        step: apTestSteps.personalExperience,
        label: 'When trading CFDs with leverage, you may open a larger position, and the following may happen:',
        question: 'largerPositionQuestion',
        options: largerPositionOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    requiredMargin: {
        value: 'requiredMargin',
        localization: { id: '', defaultMessage: '' },
        order: 30,
        orderLabel: () => 13,
        step: apTestSteps.personalExperience,
        label: 'What would be the required margin for 1 Lot (100,000) EUR/USD, if your leverage is 1:30?',
        question: 'requiredMarginQuestion',
        options: requiredMarginOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    closingOrder: {
        value: 'closingOrder',
        localization: { id: '', defaultMessage: '' },
        order: 31,
        orderLabel: () => 14,
        step: apTestSteps.personalExperience,
        label: 'What type of closing order can you choose to help limit losses when trading?',
        question: 'closingOrderQuestion',
        options: closingOrderOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    leverageLead: {
        value: 'leverageLead',
        localization: { id: '', defaultMessage: '' },
        order: 32,
        orderLabel: () => 15,
        step: apTestSteps.personalExperience,
        label: 'The market moves by 5%. Trading with how much leverage would lead to the largest potential profit or loss?',
        question: 'leverageLeadQuestion',
        options: leverageLeadOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
    priorExperience: {
        value: 'priorExperience',
        localization: { id: '', defaultMessage: '' },
        order: 33,
        orderLabel: () => 16,
        step: apTestSteps.personalExperience,
        label: 'Do you have any prior education, professional qualifications or knowledge relevant to the products offered by us?',
        question: 'priorExperienceQuestion',
        options: priorExperienceOptions,
        mandatory: () => true,
        relevant: () => true,
        dropdown: true,
        company: [companies.bdSwiss, companies.swissMarkets],
    },
}));
const appropTestStatuses = generateKeys({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    approved: {
        value: 'approved',
        label: 'Approved',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
});
const processAppropTestResults = generateKeys({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
});
export { apTestSteps, getApplicableOptions, appropTestAnnualIncome, profileNetWorth, appropTestNetWorth, appropTestDisposableIncome, appropTestEmploymentStatus, appropTestEmployerCategory, appropTestSourceOfFunds, appropTestExpectedDeposit, appropTestAttendedSeminarOrCourse, appropTestEducationLevel, appropTestFieldOfStudy, appropNatureOfTransactions, appropOriginOfFunds, appropTestHaveTraded, appropTestHowManyTimesHaveTraded, appropTestIsUsReportable, appropTestPoliticallyExposed, appropTestInitialInvestment, appropTestPast2YearsTradingExperience, appropTestTransactionsInForex, appropTestTransactionsInCommodities, appropTestWithLeverageForex, appropTestWithLeverageCommodities, appropTestStockDrops, appropTestBuyFacebookCfd, appropTestMaximumPosition, appropTestTradingWithLeverage, appropTestCfdTrading, mainTradingPurposeOptions, moneyForTradingOptions, lengthOfInvestmentOptions, levelOfEducationOptions, employmentOptions, natureOfProfessionOptions, tradesVolumeOptions, sizePerTransactionOptions, periodOfExecutionsOptions, placingSellLimitOptions, sellShortPositionOptions, largerPositionOptions, requiredMarginOptions, closingOrderOptions, leverageLeadOptions, priorExperienceOptions, appropTestAccountTurnover, profileTransactionPurpose, appropTestTransactionPurpose, appropTestAttendedSeminarOrCourseForex, appropTestAttendedSeminarOrCourseBinary, appropTestTransactionNumber, appropTestRelevantProfession, appropTestRelevantQualOrExp, appropTestRiskUnderstanding, appropTestTradingExperienceForex, appropTestTradingExperienceSharesBonds, appropTestTradingExperienceExchange, appropTestTradingExperienceOTC, appropTestTradingExperienceBinary, appropTestTradingFrequency12Months, appropTestTradingTransactions12Months, appropTestHaveTradingExperience, appropTestPast2YearsProductsSwMarkets, appropTestPast2YearsProductsBdSwiss, appropTestForexPast2YearsExperience, appropTestBinaryPast2YearsExperience, appropTestFinancialDemoPast2YearsExp, appropTestEducatedInFinancialTrading, appropTestEducationOptionInFinancialTrading, appropTestLargerSizePositions, appropTestLostInvestment, appropTestVolatileMarkets, appropTestWarningAcceptance, appropTestAcknowledgmentAcceptance, appropTestIfLoseCapital, appropTestTinReason, scoringResults, scoringResultsV2, appropTestQuestions, appropTestQuestionsV2, appropTestStatuses, processAppropTestResults, appropTestProfessionStatus, appropTestPoliticallyExposedReason, };
